module Meevo.Plugins.AppointmentBook.Services {
    export interface IAppointmentBookBuilderService {
        onApptBookStructureSuccess: (any) => any;
        initialize: () => void;
        locationInfo: string;
        loadStructure: (dates: any[], employeeCategoryIds: any[], employeeIds: any[], serviceIds: any[], resourceIds: any[], includeNoShows: boolean, priceLevels: any[], showInCascadeMode?: boolean, overrideTimeShift?: boolean, columnHeaderOrder?: string[], gender?: number, isPrecisionView?: boolean) => any;
        loadPendings(pairs: any);
        setInitialEmployees: (employeeIds: any[]) => void;
        scrollToTime: (targetTime: string) => void;
    }
}

angular.module('ApptBookApp').service('appointmentBookBuilderService', [
    'appointmentBookHelperService',
    'appointmentBookGlobalsService',
    '$rootScope',
    'restServer',
    'appointmentBookActionsService',
    'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
    '$q',
    'meevo.components.common.SecurityService',
    '$timeout',
    'meevo.components.common.IdentityService',
    'meevo.components.common.DataService',
    '$compile',
    '$translate',
    'meevo.AppSettings',
    'meevoDateFilterFilter',
    "meevo.components.common.MembershipDetailsService",
    (
        helper,
        globals,
        $rootScope,
        restServer,
        actions,
        filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService,
        $q: angular.IQService,
        security,
        $timeout: angular.ITimeoutService,
        identityService: Meevo.Components.Common.IIdentityService,
        dataService: Meevo.Components.BaseClasses.IDataService,
        $compile,
        $translate: angular.translate.ITranslateService,
        appSettings: Meevo.Components.Common.IAppSettings,
        meevoDateFilter,
        membershipDetailsService
    ) => {
        let shouldScrollTimebarIntoView = true;
        let structureResponse = null;
        let lastScheduleBottom = 0;
        let onResize = _.debounce(() => {
            helper.recalculateScrollbarHeight();
        }, 50);
        let keyupHandler = (event) => {
            /* escape */
            if (event.keyCode == 27) {
                globals.divAppointmentDetails.hide();
                actions.CheckForAdjustEditor();
            }
        };
        let previousTimeBarTop = 0;
        let workTypes;
        let hasTimeBarChanged = false;
        function onBusinessInfoSuccess(response: any, settings: any) {
            globals.businessInfo = response;

            response.showEmployeesAvailableCount = settings.appointmentBookSettings.showEmployeesAvailableCount;
            response.showResourcesAvailableCount = settings.appointmentBookSettings.showResourcesAvailableCount;
            response.enableIntegratedRegister = settings.registerSettings.enableIntegratedRegister;
            response.requireCancellationReasonWhenDeletingAnAppointment = settings.appointmentBookSettings.requireCancellationReasonWhenDeletingAnAppointment;
            response.showAddressOnAppointmentBook = settings.appointmentBookSettings.showAddressOnAppointmentBook;
            response.startAppointmentBookDayOn = settings.appointmentBookSettings.startAppointmentBookDayOn;
            response.showAddressOnSmartAssistant = settings.appointmentBookSettings.showAddressOnSmartAssistant;
            response.requireAppointmentCategory = settings.appointmentBookSettings.requireAppointmentCategory;
            response.allowAnonymousClient = settings.appointmentBookSettings.allowAnonymousClient;
            response.useGenderPreferenceWhenBookingAppointments = settings.appointmentBookSettings.useGenderPreferenceWhenBookingAppointments;
            response.displayEmployeeGenderIndicator = settings.appointmentBookSettings.displayEmployeeGenderIndicator;
            response.showAppointmentCategory = settings.appointmentBookSettings.showAppointmentCategory;
            response.clientCCFileMissingZipCode = settings.membershipSettings.clientCCFileMissingZipCode;
            response.appointmentBookIncrement = settings.appointmentBookSettings.appointmentBookIncrement;
            response.precisionMode = settings.appointmentBookSettings.precisionMode;
            response.appointmentBookPrecisionIncrement = settings.appointmentBookSettings.appointmentBookPrecisionIncrement;
            response.moveServicesAsGroup = settings.appointmentBookSettings.moveServicesAsGroup;
            response.enableStepDragging = settings.appointmentBookSettings.enableStepDragging;
            response.maxDaysToAllowServiceStepEdit = settings.appointmentBookSettings.maxDaysToAllowServiceStepEdit;
            response.maxDaysToAllowServiceStartTimeEdit = settings.appointmentBookSettings.maxDaysToAllowServiceStartTimeEdit;
            response.promptForCardOnFileWhenBookingAppointments = settings.appointmentBookSettings.promptForCardOnFileWhenBookingAppointments;
            response.promptDragDropAppointmentOnMobile = settings.appointmentBookSettings.promptDragDropAppointmentOnMobile;
            response.showTimeClockIndicators = settings.appointmentBookSettings.showTimeClockIndicators;

            globals.defaultAppointmentBookView = settings.appointmentBookSettings.defaultAppointmentBookView;
            globals.defaultColumnPercent = settings.appointmentBookSettings.defaultAppointmentBookColumnZoom;
            globals.defaultRowPercent = settings.appointmentBookSettings.defaultAppointmentBookTimeZoom;
            globals.requestedAppointmentDefaultFlag = settings.appointmentBookSettings.requestedAppointmentDefaultFlag;
            globals.printServiceModule = settings.appointmentBookSettings.printServiceModule;
            globals.appointmentNoShowFeePercentage = settings.appointmentBookSettings.appointmentNoShowFeePercentage;
            globals.applyNoShowFeeToAddOns = settings.appointmentBookSettings.applyNoShowFeeToAddOns;
            globals.numberOfDimensionsPerRequest = settings.appointmentBookSettings.appointmentBookChunkSize;
            globals.pageSize = settings.appointmentBookSettings.appointmentBookPageSize;
            globals.onlyShowServicesPerformedByEmployeeAndResource = settings.appointmentBookSettings.onlyShowServicesPerformedByEmployeeAndResource;
            globals.isAmPmFormat = appSettings.APP_TIME_FORMAT === Meevo.Model.TimeFormatEnum.TimeFormat12;
            globals.primaryAppointmentStyle = settings.appointmentBookSettings.primaryAppointmentStyle;
            globals.productUsageTracking = settings.generalSettings.productUsageTracking;

            globals.isEmployeeView = helper.getUserAppointmentBookView() == Meevo.Model.EmployeeAppointmentBookViewEnum.All ?
                globals.defaultAppointmentBookView : true;

            $rootScope.appointmentBookIncrement = helper.convertAppointmentBookIncrementToNumber(globals.businessInfo.appointmentBookIncrement);
            globals.displayPrecisionTimingToggle = globals.businessInfo.precisionMode && (globals.businessInfo.appointmentBookIncrement == Meevo.Model.AppointmentIncrementEnum.Min10 ||
                globals.businessInfo.appointmentBookIncrement == Meevo.Model.AppointmentIncrementEnum.Min15);

            $rootScope.hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            $rootScope.minutes = [];
            for (var i = 0; i < 60; i += $rootScope.appointmentBookIncrement) {
                if (i <= 10) {
                    $rootScope.minutes.push(`0${i}`);
                } else {
                    $rootScope.minutes.push(i + '');
                }
            }
            $rootScope.amPmDesignator = ['AM', 'PM'];
            globals.timeZoneOffset = response.timeZoneOffset;
        }

        //There is essentially a copy of this function in mobileApptBook.controller excluding the que section - any changes made here also need to be made there
        function setHours(parentDimension: any) {
            let startTime;
            let endTime;

            for (let date of filterActions.dates) {
                const businessHours = helper.getBusinessHoursForDate(date);
                if (businessHours.isEnabled) {
                    if (!startTime) {
                        startTime = moment(businessHours.startTime);
                        endTime = moment(businessHours.endTime);
                    } else {
                        const potentialStartTime = moment(businessHours.startTime);
                        if (potentialStartTime < startTime) {
                            startTime = potentialStartTime;
                        }
                        const potentialEndTime = moment(businessHours.endTime);
                        if (potentialEndTime > endTime) {
                            endTime = potentialEndTime;
                        }
                    }
                }
            }

            if (!startTime || !endTime) {
                let businessHours = getOpenBusinessHours();

                if (!startTime) {
                    startTime = _.min(_(businessHours).map((hours: any) => moment(hours.startTime))) || moment('9:00', 'H:m');
                }

                if (!endTime) {
                    endTime = _.max(_(businessHours).map((hours: any) => moment(hours.endTime))) || moment('17:00', 'H:m');
                }
            }

            const queue = [];
            queue.push(parentDimension);
            while (queue.length > 0) {
                const dimension = queue.shift();
                for (let innerDimension of dimension.innerDimensions) {
                    queue.push(innerDimension);
                }
                if (dimension.startTime) {
                    const startTimeDuration = moment.duration(dimension.startTime);
                    // check if dimension.startTime is earlier than startTime, if yes, adjust globals.bookStartTime
                    if (startTimeDuration < moment.duration(startTime)) {
                        startTime.startOf('day').add(startTimeDuration);
                    }
                }
            }

            // Subtract one hour from earliest opening time and add one hour to latest closing time.  Add causes a mutation so need to capture date before add/sub an hour so
            // can check if modification causes time to cross over a day.
            const originalStartTimeDate = moment(startTime).startOf('day');
            startTime.add((-60 - helper.getOffsetMinutes(moment(startTime))), 'm');
            const originalEndTimeDate = moment(endTime).startOf('day');
            endTime.add((60 + helper.getOffsetMinutes(moment(endTime))), 'm');
            globals.bookStartTime = moment(startTime).startOf('day') < originalStartTimeDate ? moment('0:00', 'H:m') : startTime;
            globals.bookEndTime = moment(endTime).startOf('day') > originalEndTimeDate ? moment('23:59', 'H:m') : endTime;
        }

        function getGenderIconHtml(column: any) {
            let imageHtml = '';
            if (column.genderEnum && this.globals.businessInfo.displayEmployeeGenderIndicator) {
                let imageUrl = '';
                switch (column.genderEnum) {
                    case Meevo.Model.GenderEnum.Female:
                        imageUrl = './assets/images/appointmentBook/EmpGender_Female_20.png';
                        break;
                    case Meevo.Model.GenderEnum.Male:
                        imageUrl = './assets/images/appointmentBook/EmpGender_Male_20.png';
                        break;
                }
                if (imageUrl != '') {
                    imageHtml = `<img class="gender-small-icon" src="${imageUrl}" />`;
                }
            }

            return imageHtml;
        }


        var timeBarTimeOutId;

        function getCurrentTimeTop() {
            return Math.floor((helper.getBusinessTime().totalMinutes() - globals.bookStartTime.totalMinutes()) / $rootScope.appointmentBookIncrement) * globals.cellHeight;
        }

        function setCurrentTimeBarPosition(shouldSetTimeout: any, fromTimer: boolean = false) {
            let top = getCurrentTimeTop();
            if (fromTimer && previousTimeBarTop != top) {
                if (!isPaused) {
                    service.writeScheduleTimeClockActions(globals.columnBookings).then(() => {
                        service.writeYieldManagementPrograms(globals.columnBookings, (globals.opacityFilterSelections || {}).programId);
                    })
                }
                else {
                    hasTimeBarChanged = true;
                }
            }
            previousTimeBarTop = top;
            $('.column > .divCurrentTimeBar').css('top', top);

            $('.standardCellTime, .cellCount').removeClass('divCurrentTimeBarColor');
            $('.timeRow:nth-child(' + ((top / globals.cellHeight) + 1) + ')>.standardCellTime').addClass('divCurrentTimeBarColor');
            $('.timeRow:nth-child(' + ((top / globals.cellHeight) + 1) + ')>.cellCount').addClass('divCurrentTimeBarColor');

            if (shouldSetTimeout) {
                service.stopTimeBarTimer();
                timeBarTimeOutId = setTimeout(() => {
                    setCurrentTimeBarPosition(true, true);
                }, 60000); // wait a minute before calling again
            }
        }

        var scrolledToTime: string = null;

        function scrollToTime(targetTime: string): void {
            if (globals.bookStartTime && globals.scrollContainer) {
                const time = moment(targetTime, 'HH:mm');
                let top = helper.convertMinutesToPixels(time.totalMinutes() - globals.bookStartTime.totalMinutes(), true);
                let maxTop = globals.scrollContainer.prop('scrollHeight') - globals.scrollContainer.height();
                if (top > maxTop) {
                    top = maxTop;
                }
                globals.scrollContainer.scrollTop(top);
            } else {
                clearTimeout(timeBarTimeOutId);
                timeBarTimeOutId = setTimeout(() => {
                    scrollToTime(targetTime);
                }, 3000);
            }
        }

        function scrollTimebarIntoView() {
            if ($('.divCurrentTimeBar').is(':visible')) {
                // Notice issue with scrollContainer not honoring scroll at this point after you open and close book for first time.  $timeout seems to fix it.
                $timeout(() => {
                    const top = parseInt($('.divCurrentTimeBar').css('top'));
                    globals.scrollContainer.scrollTop(top);
                    $('#timeContainerLeft').scrollTop(top);
                    $('#timeContainerRight').scrollTop(top);
                });
            } else if (globals.scrollTime) {
                const scrollTimeRow = $('#divRows').find(`#${globals.scrollTime}`);
                if (scrollTimeRow) {
                    const top = scrollTimeRow.position().top + globals.extraScrollTime;
                    globals.scrollContainer.scrollTop(top);
                    $('#timeContainerLeft').scrollTop(top);
                    $('#timeContainerRight').scrollTop(top);
                    globals.scrollTime = undefined;
                    globals.extraScrollTime = undefined;
                }
            }
        }

        let isPausedCallback;
        let isPaused = false;
        globals.onApptBookDataSuccess = response => {
            if (isPaused) {
                isPausedCallback = () => {
                    globals.onApptBookDataSuccess(response);
                }
                return;
            }

            //console.log('onApptBookDataSuccess');
            //console.time('onApptBookDataSuccess');

            var hasDimensions = makeDimensionDataRequest();

            $timeout(() => {
                service.clearColumns(response);
                service.writeBookedPercentages(response);
                service.writeAppointments(response);
                service.writeBlocks(response);

                var relatedColumnIds = service.writeSchedules(response);

                relatedColumnIds.forEach(columnId => {
                    var column: any = _.where(globals.columnBookings, { columnId: columnId })[0];
                    if (moment(column.date, globals.columnDateFormat).format(globals.columnDateFormat) === helper.getBusinessTime().format(globals.columnDateFormat)) {
                        helper.WriteDiv({
                            className: 'divCurrentTimeBar',
                            style: `height:${globals.cellHeight}px;width:${globals.columnWidth}px;`,
                            container: `#${column.columnId}`,
                        });
                    }
                    column.isExpanded = false;
                    if (helper.FindExpandedHeaderColumn(`Header${column.columnId}`).length > 0) {
                        column.isExpanded = true;
                    }
                });

                helper.AdjustColumnsForMultiBooking(relatedColumnIds, false);

                globals.disableDateChange = hasDimensions;

                resizeContainer();

                setCurrentTimeBarPosition(!hasDimensions);

                if (shouldScrollTimebarIntoView && !scrolledToTime) {
                    scrollTimebarIntoView();
                    shouldScrollTimebarIntoView = false;
                }

                if (scrolledToTime) {
                    scrollToTime(scrolledToTime);
                    scrolledToTime = null;
                    shouldScrollTimebarIntoView = false;
                }

                if (!hasDimensions) {
                    service.applyOpacityFiltering(globals.opacityFilterSelections);
                }

                service.writeWalkinStatus(response);
                service.writeMembershipIcons(response);

                helper.setHeaderCellRootWidth();
                helper.recalculateScrollbarHeight();
            });

            //console.timeEnd('onApptBookDataSuccess');
        };

        function setHeaderCellRootWidth() {
            if ($('#divColumns').width() < $('#divAppointmentBookScrollContainer').width()) {
                $('#divRootHeaders').width($('#divColumns').width()).css('overflow', 'visible');
                const lastHeaderCellRoot = $('#divHeader1 > .headerCellRoot').last();
                if (lastHeaderCellRoot.data('oldwidth') != null) {
                    lastHeaderCellRoot.width(lastHeaderCellRoot.data('oldwidth'));
                }
            } else {
                $('#divRootHeaders').width($('#divAppointmentBookScrollContainer').width()).css('overflow', 'hidden');
                const lastHeaderCellRoot = $('#divHeader1 > .headerCellRoot').last();
                if (lastHeaderCellRoot.data('oldwidth') == null) {
                    lastHeaderCellRoot.data('oldwidth', lastHeaderCellRoot.width());
                }
                lastHeaderCellRoot.css('width', $('#divColumns').width() + 100);
            }
        };

        function makeDimensionDataRequest() {
            let hasDimensions = true;
            const filters = new Meevo.Plugins.AppointmentBook.Models.AppointmentBookFilters();
            filters.displayNoShows = filterActions.displayNoShows;

            for (let i = globals.lastRequestedDimension; i < globals.lastRequestedDimension + globals.numberOfDimensionsPerRequest; i++) {
                if (i >= globals.columnBookings.length) {
                    break;
                }

                const booking = globals.columnBookings[i];
                if (booking.resourceUnitId) {
                    filters.dimensionDates.push({
                        entityId: booking.resourceUnitId,
                        date: booking.date
                    });
                } else {
                    filters.dimensionDates.push(<Meevo.Plugins.AppointmentBook.Models.EmployeeDimensionDate>{
                        entityId: booking.employeeId,
                        date: booking.date,
                        isShared: booking.isShared,
                        managedByLocationId: booking.managedByLocationId
                    });
                }
            }

            if (filters.dimensionDates.length > 0 || globals.loadBookOnApplyFilter) {
                restServer.LoadAppointmentBookData(globals.isEmployeeView, filters, globals.onApptBookDataSuccess, filterActions.includeFilterData);
            } else {
                hasDimensions = false;
                // Remove all columns that were marked to be removed
                for (let j = globals.columnBookings.length - 1; j >= 0; j--) {
                    if (globals.columnBookings[j].remove != undefined && globals.columnBookings[j].remove) {
                        $(globals.columnBookings[j]).remove();
                    }
                }
                if (service.deferScrollLeft) {
                    service.deferScrollLeft.resolve();
                }
            }
            globals.lastRequestedDimension += globals.numberOfDimensionsPerRequest;
            return hasDimensions;
        };

        function resizeContainer() {
            const containerWidth = $('#divRows').position().left + $('#divRows').width();
            const containerHeight = globals.timeContainerHeight;
            $('#divAppointmentBookContainer').css({ "height": containerHeight, "width": containerWidth });
            $('#divColumns').css('height', containerHeight);
            $('#divClickOverlay').css('height', containerHeight);
            setHeaderCellRootWidth();
        }

        globals.onApptBookDataMoveSuccess = (responseData, affectedColumns = []) => {
            if (!globals.isEmployeeView) {
                var columnId;
                responseData.forEach(res => {
                    columnId = $(`[data-resource-unit-id="${res.resourceUnitId}"][class=column]`).attr('id');
                    let block = $(`#${columnId} > .block`);
                    if (block.length > 0) {
                        block.remove();
                    } else {
                        columnId = helper.GetColumnId(moment(res.date).format('M-D-YYYY'), res.resourceUnitId);
                        $(`#${columnId} > .block`).remove();
                    }
                });
                service.writeBlocks(responseData);
                service.writeSchedules(responseData);
                callExpandCollapseMethod(responseData, true);
            } else {
                var response = [];
                affectedColumns.forEach(affectedColumn => {
                    if (globals.isEmployeeView) {
                        const columnId = helper.GetColumnId(affectedColumn.date.format('M-D-YYYY'), affectedColumn.entityId);
                        response.push(_.where(globals.columnBookings.slice(), { columnId: columnId })[0]);
                    } else {
                        response.push(_.where(globals.columnBookings.slice(), { resourceId: affectedColumn.entityId, date: affectedColumn.date.format('M/D/YYYY') })[0]);
                    }
                });
                service.writeSchedules(response);
                callExpandCollapseMethod(response, false);
            }
        }

        function callExpandCollapseMethod(response: any, isResourceView: any) {
            response.forEach(resp => {
                var columnId;
                if (isResourceView) {
                    columnId = helper.GetColumnId(resp.date, helper.getEntityId(resp));
                } else {
                    columnId = resp.columnId;
                }
                const column: any = _.findWhere(globals.columnBookings, { columnId: columnId });
                if (column.isExpanded) {
                    helper.AdjustColumnCellsForMultiBooking(columnId, false);
                }
            });
        }

        function setCurrentPage() {
            if (filterActions.scrollToCurrentDate && globals.totalPages > 1) {
                let firstIndex = _.findIndex(globals.totalColumnBookings,
                    (booking: any) => {
                        return helper.getBusinessTime().isSame(booking.fullDate, "day");
                    });
                if (firstIndex >= 0) {
                    globals.currentPage = Math.floor(firstIndex / globals.pageSize) + 1;
                }
            }
        }

        function clampDateToInterval(date, offset) {
            return date.minute(Math.floor(date.minute() / offset) * offset).second(0);
        }

        function getOpenBusinessHours() {
            return _(globals.businessInfo.businessHours).filter(businessHours => businessHours.isEnabled && !!businessHours.startTime && !!businessHours.endTime);
        }

        var service = {
            $rootScope: undefined,
            currentPage: 0,
            deferScrollLeft: null,
            locationInfo: undefined,
            postInit: undefined,
            events: undefined,
            eventData: [],
            pause() {
                isPaused = true;
            },
            stopTimeBarTimer() {
                clearTimeout(timeBarTimeOutId);
            },
            continue() {
                isPaused = false;
                if (isPausedCallback) {
                    isPausedCallback();
                    isPausedCallback = undefined;
                }

                if (hasTimeBarChanged) {
                    hasTimeBarChanged = false;
                    service.writeScheduleTimeClockActions(globals.columnBookings);
                }
            },
            onApptBookStructureSuccess(response, overrideTimeShift?: boolean) {
                service.$rootScope = $rootScope;
                shouldScrollTimebarIntoView = !overrideTimeShift;
                globals.appointmentBookLoaded = true;
                globals.isPasting = false;
                globals.restictedIds = {};
                filterActions.cellWidthPercent = $rootScope.onFirstLoad === true ? globals.defaultColumnPercent : filterActions.cellWidthPercent;
                filterActions.cellHeightPercent = $rootScope.onFirstLoad === true ? globals.defaultRowPercent : filterActions.cellHeightPercent;

                if ($rootScope.onFirstLoad === true) {
                    filterActions.initZoomLevel();
                    filterActions.getPendingServices();
                }

                this.loadEvents().then((data) => {
                    service.events = data;
                    service.deferScrollLeft = $q.defer();
                    globals.currentPage = 1;
                    service.WriteStructure(response);

                    $rootScope.onFirstLoad = false;

                    $q.all([
                        service.deferScrollLeft.promise,
                        helper.loadCounts(true, true, filterActions.dates)
                    ]).then(() => {
                        $timeout(() => {
                            if (device.ios()) {
                                let heightAdjustment = device.iphone() ? '34px' : '92px';
                                $('#divAppointmentBookRootContainer').css({
                                    'position': 'fixed',
                                    'height': `calc(100% - ${heightAdjustment})`,
                                });
                            }

                            globals.scrollContainer.scrollLeft(globals.bookLastScrollXPosition);

                            helper.recalculateScrollbarHeight();
                        });
                    });
                });
            },
            isAppointmentServiceFilteredIn(appointmentService, filter) {
                if (!filter) {
                    return true;
                }

                //TODO: does this need to compare against both Transition and Final State?

                const finalState = filter.appointStatusFilter.appointmentFinalStateEnum;
                const transitionState = filter.appointStatusFilter.appointmentTransitionStateEnum;
                const confirmState = filter.confirmStatusFilter.appointConfirmStateEnum;

                if (
                    (finalState.length > 0 && finalState.indexOf(appointmentService.finalState) === -1) ||
                    (transitionState.length > 0 && transitionState.indexOf(appointmentService.transitionState) === -1)
                ) {
                    return false;
                }

                if (confirmState.length > 0 && confirmState.indexOf(appointmentService.appointmentConfirmState) === -1) {
                    return false;
                }

                if (filter.hasNotes && !appointmentService.hasNote) {
                    return false;
                }

                if (filter.hasClientNotes && !appointmentService.hasClientNote) {
                    return false;
                }

                if (filter.bookedOnline && appointmentService.bookingMethod !== Meevo.Model.BookingMethodEnum.Online) {
                    return false;
                }

                if (filter.bookedViaBookingAgent && appointmentService.bookingMethod !== Meevo.Model.BookingMethodEnum.BookingAgent) {
                    return false;
                }

                if (globals.isEmployeeView && filter.selectedResource && appointmentService.resourceId != filter.selectedResource.id) {
                    return false;
                }

                if (globals.isEmployeeView && filter.selectedEquipment && !_.find(appointmentService.equipmentIds, (equipmentId) => equipmentId == filter.selectedEquipment.id)) {
                    return false;
                }

                if (filter.selectedBookedBy && appointmentService.updatedByUserIdLoaded &&
                    (!appointmentService.bookedByUserId || appointmentService.bookedByUserId != filter.selectedBookedBy.id)) {
                    return false;
                }

                if (filter.selectedClientType && appointmentService.clientTypeId != filter.selectedClientType.id) {
                    return false;
                }

                if (filter.selectedApptCategory && appointmentService.appointmentCategoryId != filter.selectedApptCategory.id) {
                    return false;
                }

                if (filter.isFirstTimeServiceCategoryBooked && !appointmentService.isFirstTimeServiceCategoryBooked) {
                    return false;
                }

                if (filter.isNewClient && !appointmentService.isNewClientForLocation) {
                    return false;
                }

                if (filter.isWalkin && appointmentService.bookingType !== Meevo.Model.BookingTypeEnum.Walkin) {
                    return false;
                }

                if (!globals.isEmployeeView && filter.isUnassignedEmployee && appointmentService.employeeId != emptyGuid()) {
                    return false;
                }

                if (filter.isRebooked && appointmentService.reBookCount == 0) {
                    return false;
                }

                if (filter.isRepeatClientBusiness && appointmentService.isNewClientForBusiness) {
                    return false;
                }

                if (filter.isRepeatClientEmployee && appointmentService.isNewClientForEmployee) {
                    return false;
                }

                if (filter.appointmentId && appointmentService.appointmentId !== filter.appointmentId) {
                    return false;
                }

                if (filter.bookedViaMyMeevo && appointmentService.bookingMethod !== Meevo.Model.BookingMethodEnum.MyMeevo) {
                    return false;
                }

                let clipboardItemIds: any = _.findWhere(globals.cutCopyIds, { appointmentServiceId: appointmentService.id, isPasted: false });

                if (clipboardItemIds) {
                    let clipboardItem = $('#divCutCopy').find(`div[data-id="${clipboardItemIds.id}"]`);
                    if (clipboardItem.length > 0 && clipboardItem.data('clipboardAction') == Meevo.Model.ClipboardActionEnum.Cut) {
                        return false;
                    }
                }

                return true;
            },
            applyOpacityFiltering(opacityFilterSelections) {
                let programId;
                if (opacityFilterSelections) {
                    opacityFilterSelections.programId = (opacityFilterSelections.program || {}).id
                    programId = opacityFilterSelections.programId;
                }
                if (programId != (globals.opacityFilterSelections || {}).programId) {
                    service.writeYieldManagementPrograms(globals.columnBookings, programId);
                }

                globals.opacityFilterSelections = opacityFilterSelections;
                if (globals.loadBookOnApplyFilter) {
                    globals.loadBookOnApplyFilter = false;
                    filterActions.filterBook();
                    return;
                }

                $('#divAppointmentBookContainer div.appointmentOverlay').remove();
                if (!opacityFilterSelections) {
                    return;
                }

                let idsToServer = [];
                let idsToExclude = [];
                let idsFullList = [];
                globals.columnBookings.forEach(columnBooking => {
                    if (!columnBooking.appointmentServices) {
                        return;
                    }
                    columnBooking.appointmentServices.forEach(appointmentService => {
                        if (!this.isAppointmentServiceFilteredIn(appointmentService, opacityFilterSelections)) {
                            idsToExclude.push(appointmentService.id);
                        } else {
                            idsToServer.push(appointmentService.id);
                        }
                        idsFullList.push({
                            id: appointmentService.id,
                            bookedByUserId: appointmentService.bookedByUserId,
                            updatedByUserIdLoaded: appointmentService.updatedByUserIdLoaded
                        })
                    });
                });

                const serverPromises = [];

                if (opacityFilterSelections.hasUnsubmittedForms) {
                    serverPromises.push(this.filterUnsubmittedForms(idsToServer, idsToExclude));
                }

                if (opacityFilterSelections.selectedBookedBy) {
                    serverPromises.push(this.filterAppointmentServiceBookedBy(idsFullList, idsToExclude, opacityFilterSelections.selectedBookedBy));
                }

                if (idsToServer.length === 0) {
                    if (serverPromises.length > 0) {
                        idsToServer = idsToExclude.slice(0);
                    } else {
                        helper.addOverlay(idsToExclude);
                        return;
                    }
                }

                // there's no need to check services that are already going to be "filtered in"
                // check any remaining ones for more expensive server-side checks

                $q.all(serverPromises).finally(() => {
                    helper.addOverlay(_(idsToExclude).uniq());
                });
            },
            filterAppointmentServiceBookedBy(idsFullList, idsToExclude, filterBookedBy) {
                //if not loaded AS/BookedBy or apoointment added, (re) load first
                let isAnyBookedByNotLoaded = _(idsFullList).any(item => item.updatedByUserIdLoaded === undefined );
                if (isAnyBookedByNotLoaded) {
                    const formsRequest: any = {
                        AppointmentServiceIds: _(idsFullList).pluck('id'),
                        AppointTransitionStateEnum: Meevo.Model.AppointStateEnum.Booked
                    };

                    return dataService.customMethodData('api/AppointmentBook/AppointmentServiceUpdatedBy/List', 'post', formsRequest)
                        .then(response => {
                            let appointmentServiceBookedByList = response.data;
                            globals.columnBookings.forEach(columnBooking => {
                                if (!columnBooking.appointmentServices) {
                                    return;
                                }
                                columnBooking.appointmentServices.forEach(appointmentService => {
                                    //merge Booked By with an existing Appointment Services objects
                                    let appointmentServiceFromList = _(appointmentServiceBookedByList).findWhere({ appointmentServiceId: appointmentService.id });
                                    if (appointmentServiceFromList) {
                                        appointmentService.bookedByUserId = appointmentServiceFromList.updatedByUserId;
                                    }
                                    appointmentService.updatedByUserIdLoaded = true;
                                    //filter out
                                    if (appointmentService.bookedByUserId != filterBookedBy.id) {
                                        idsToExclude.push(appointmentService.id);
                                    }
                                });
                            });
                        });
                }
                else {
                    return $q.resolve();
                }
            },
            filterUnsubmittedForms(idsToServer, idsToExclude) {
                const formsRequest: any = {
                    AppointmentServicesList: idsToServer,
                };

                return dataService.customMethodData('api/DocsAndForms/AppointmentServiceForm/Check', 'post', formsRequest)
                    .then(formsResponse => {
                        _(formsResponse.data).each((formAppointmentService) => {
                            if (!formAppointmentService.hasUnsubmittedForms) {
                                idsToExclude.push(formAppointmentService.appointmentServiceId);
                            }
                        });
                    });
            },
            writeWalkinStatus(response) {
                security.checkModuleAccess(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_WALKINMANAGER
                    + Meevo.Components.Common.SecurityParts.KEY_PART_READ).
                    then((securityAccess: Meevo.Model.SecurityAccessEnum) => {
                    if (securityAccess != Meevo.Model.SecurityAccessEnum.Grant) {
                        return;
                    }

                    dataService.customMethodData("/api/timeclock/locationTime", "get", {}).then(timeResponse => {
                        let businessDate = moment(timeResponse.data.locationTime).startOf("day");
                        let relevantServices = _.filter(_.flatten(_.pluck(_.flatten(_.pluck(response, "appointments")), "services")), service=> {
                            return service.clientType === Meevo.Model.ClientTypeEnum.Client &&
                                service.transitionState === Meevo.Model.AppointStateEnum.WalkInPending &&
                                moment(service.startDateTime).startOf("day").isSame(businessDate)
                        });

                        if (relevantServices.length === 0) {
                            return;
                        }

                        restServer.loadWalkinStatus(_(relevantServices).pluck("id")).then(res => {
                            _(res.data).where({ status: Meevo.Model.WalkInStatusEnum.WaitingAndPresent }).forEach(status => {
                                let matchingServices = _(relevantServices).where({ id: status.appointmentServiceId });

                                matchingServices.forEach(matchingService => {
                                    //TODO:  Implement correct final UI.  This is just an example of what we
                                    // did for membership status.
                                    const indicatorHtml = `<md-icon class="walkInStatusIndicator" md-svg-icon="assets/images/icons/walkin_checkmark.svg" ></md-icon>`;

                                    $(`[data-id="${matchingService.id}"] #iconsContainer`).append($compile(indicatorHtml)($rootScope));
                                    helper.updateAppointmentService(matchingService.id);
                                });
                            })
                        });
                    });
                })

            },
            writeScheduleTimeClockActions(response, includeCompletedSchedules=false) {
                if (!globals.isEmployeeView || !globals.businessInfo.showTimeClockIndicators) {
                    return $q.resolve();
                }
                let relevantSchedules = [];
                response.forEach(r => {
                    if (r.schedules) {
                        relevantSchedules.push(..._(r.schedules).filter(schedule => {
                            if (!schedule.workTypeId) {
                                return false;
                            }

                            let startTime = moment(schedule.startTime, 'H-m');
                            let endTime = moment(schedule.endTime, 'H-m');
                            schedule.startDateTime = moment(r.date).set("hour", startTime.get("hour"))
                                .set("minute", startTime.get("minute"));
                            schedule.endDateTime = moment(r.date).set("hour", endTime.get("hour"))
                                .set("minute", endTime.get("minute"));
                            let workType = _(workTypes).findWhere({ id: schedule.workTypeId });
                            return workType && workType.mustPunchIn && workType.isBookableTime
                        }));
                    }
                })

                let scheduleKeys = relevantSchedules.map(schedule => {
                    return {
                        employeeId: schedule.employeeId,
                        startDateTime: schedule.startDateTime.toDate(),
                        endDateTime: schedule.endDateTime.toDate(),
                        workTypeId: schedule.workTypeId
                    }
                });

                return restServer.loadScheduleTimeClockActions(scheduleKeys, includeCompletedSchedules).then(scheduleTimeClockResponse => {
                    let targetScheduleElements = [];
                    scheduleTimeClockResponse.data.forEach(scheduleTime => {
                        let matchingSchedule = _(relevantSchedules).find(schedule => {
                            return schedule.startDateTime.isSame(scheduleTime.employeeScheduleKey.startDateTime) &&
                                schedule.employeeId === scheduleTime.employeeScheduleKey.employeeId
                        });
                        const columnId = helper.GetColumnId(matchingSchedule.startDateTime.format(globals.columnDateFormat),
                            scheduleTime.employeeScheduleKey.employeeId);
                        const column = _(globals.columnBookings).findWhere({ columnId: columnId });
                        //replace actions for employee id/start date/time
                        column.scheduleTimeClockActions = column.scheduleTimeClockActions || [];
                        column.scheduleTimeClockActions = column.scheduleTimeClockActions.filter(action => {
                            action.employeeScheduleKey.startDateTime != scheduleTime.employeeScheduleKey.startDateTime &&
                                action.employeeScheduleKey.employeeId != scheduleTime.employeeScheduleKey.employeeId
                        });

                        if (!matchingSchedule || (scheduleTime.clockInTime && matchingSchedule.startDateTime.isAfter(scheduleTime.clockInTime) &&
                            (!scheduleTime.clockOutTime || (matchingSchedule.endDateTime.isBefore(scheduleTime.clockOutTime))))) {
                            return;
                        }

                        let scheduleElement = $(`#${columnId}_${matchingSchedule.scheduleIndex}`);
                        scheduleElement.find(".scheduleTimeClockOverlay,.scheduleTimeClockOverlayLabel").remove();
                        let divsDetails = [];
                        if (scheduleTime.isRunningLate || scheduleTime.isLate) {
                            let lateScheduleTime = jQuery.extend(true, [], scheduleTime);
                            lateScheduleTime.startDateTime = matchingSchedule.startDateTime
                            let scheduleStartCell = helper.GetCellByIds(matchingSchedule.startDateTime.format(globals.columnDateFormat),
                                lateScheduleTime.startDateTime.format('H-m'),
                                lateScheduleTime.employeeScheduleKey.employeeId);
                            let clockInTime = moment(lateScheduleTime.clockInTime);
                            // only need to bump out overlay another row to occupy current time row when its not at the end of the schedule
                            if (lateScheduleTime.isRunningLate && !clockInTime.isSame(matchingSchedule.endDateTime)) {
                                clockInTime = clockInTime.add("minute", $rootScope.appointmentBookIncrement);
                            }
                            lateScheduleTime.endDateTime = clampDateToInterval(clockInTime, $rootScope.appointmentBookIncrement);
                            let clockInTimeCell = helper.GetCellByIds(clockInTime.format(globals.columnDateFormat),
                                lateScheduleTime.endDateTime.format('H-m'), lateScheduleTime.employeeScheduleKey.employeeId);
                            if (lateScheduleTime.isRunningLate) {
                                divsDetails.push({
                                    label: "LABEL_RUNNING_LATE",
                                    top: 0,
                                    height: clockInTimeCell.top
                                        - scheduleStartCell.top - parseInt(scheduleElement.css("border-top-width")),
                                    className: "runningLate"
                                })
                            }
                            else {
                                let height = clockInTimeCell.top - scheduleStartCell.top;
                                if (height > 0) {
                                    divsDetails.push({
                                        label: "LABEL_LATE",
                                        top: 0,
                                        height: height - parseInt(scheduleElement.css("border-top-width")),
                                        className: "late"
                                    })
                                }
                            }
                            column.scheduleTimeClockActions.push(lateScheduleTime);
                        }

                        if (scheduleTime.isLeftEarly) {
                            let leftEarlyScheduleTime = jQuery.extend(true, [], scheduleTime)
                            leftEarlyScheduleTime.endDateTime = matchingSchedule.endDateTime;
                            let scheduleEndCell = helper.GetCellByIds(matchingSchedule.endDateTime.format(globals.columnDateFormat),
                                matchingSchedule.endDateTime.format('H-m'),
                                leftEarlyScheduleTime.employeeScheduleKey.employeeId);
                            let clockOutTime = moment(leftEarlyScheduleTime.clockOutTime);
                            leftEarlyScheduleTime.startDateTime = clampDateToInterval(clockOutTime, $rootScope.appointmentBookIncrement);
                            let clockOutTimeCell = helper.GetCellByIds(clockOutTime.format(globals.columnDateFormat),
                                leftEarlyScheduleTime.startDateTime.format('H-m'), leftEarlyScheduleTime.employeeScheduleKey.employeeId);
                            divsDetails.push({
                                label: "LABEL_LEFT_EARLY",
                                bottom: 0,
                                height: scheduleEndCell.top - clockOutTimeCell.top - parseInt(scheduleElement.css("border-top-width")),
                                className: "leftEarly"
                            })
                            column.scheduleTimeClockActions.push(leftEarlyScheduleTime);
                        }

                        let divDetailsHtml = [];
                        divsDetails.forEach(divDetail => {
                            let topCss = angular.isDefined(divDetail.top) ? `top:${divDetail.top}px;` : "";
                            let bottomCss = angular.isDefined(divDetail.bottom) ? `bottom:${divDetail.bottom}px;` : "";
                            divDetailsHtml.push(service.GetHelperDiv(
                                `scheduleTimeClockOverlay ${divDetail.className}`,
                                "",
                                "",
                                `height:${divDetail.height}px;${topCss}${bottomCss}`
                            ));
                            divDetailsHtml.push(service.GetHelperDiv(
                                `scheduleTimeClockOverlayLabel`,
                                "",
                                `<span>${$translate.instant(divDetail.label)}</span>`,
                                `height:${divDetail.height}px;${topCss}${bottomCss}line-height:${divDetail.height}px`
                            ));
                        });
                        if (divDetailsHtml.length) {
                            targetScheduleElements.push({ scheduleElement: scheduleElement, divDetailsHtml: divDetailsHtml });
                        }
                    })

                    targetScheduleElements.forEach(targetScheduleElement => {
                        targetScheduleElement.scheduleElement.append(targetScheduleElement.divDetailsHtml);
                    })
                })

            },
            writeYieldManagementPrograms(columnBookings, filteredProgramId) {
                if (!globals.isEmployeeView) {
                    return;
                }
                let requestItems = columnBookings.map(columnBooking => {
                    const columnId = helper.GetColumnId(columnBooking.date,
                        columnBooking.employeeId);
                    const column = _(globals.columnBookings).findWhere({ columnId: columnId });
                    return {
                        employeeId: columnBooking.employeeId,
                        date: moment(columnBooking.date).toDate(),
                        restrictedTimeRanges: (column.scheduleTimeClockActions || []).filter(restrictedTime =>
                            restrictedTime.employeeScheduleKey.employeeId === columnBooking.employeeId &&
                            moment(restrictedTime.employeeScheduleKey.startDateTime).startOf('day').isSame(columnBooking.date)
                        )

                            .map(restrictedTime => {
                                return {
                                    startDateTime: restrictedTime.startDateTime.toDate(),
                                    endDateTime: restrictedTime.endDateTime.toDate()
                                }
                            })
                    }
                });

                let programIterator = (programs, columnBooking, schedule, scheduleElement, targetScheduleElements) => {
                    programs.forEach(program => {
                        let startTime = moment(program.timeRange.startDateTime);
                        let endTime = moment(program.timeRange.endDateTime);

                        // clampDateToInterval mutates the object
                        const clampedStartTime = clampDateToInterval(moment(startTime), $rootScope.appointmentBookIncrement);
                        const clampedEndTime = clampDateToInterval(moment(endTime), $rootScope.appointmentBookIncrement);

                        const topOffset = helper.convertMinutesToPixels(startTime.diff(clampedStartTime, 'minutes'));
                        const bottomOffset = helper.convertMinutesToPixels(endTime.diff(clampedEndTime, 'minutes'));

                        if (endTime.isAfter(schedule.startDateTime) && schedule.endDateTime.isAfter(startTime)) {
                            let timeTopCell = helper.GetCellByIds(startTime.format(globals.columnDateFormat),
                                clampedStartTime.format('H-m'), program.employeeId);
                            let timeBottomCell = helper.GetCellByIds(endTime.format(globals.columnDateFormat),
                                clampedEndTime.format('H-m'), program.employeeId);
                            let scheduleTop = helper.GetCellByIds(columnBooking.date, schedule.startTime, program.employeeId).top;
                            let scheduleBottom = helper.GetCellByIds(columnBooking.date, schedule.endTime, program.employeeId).top;
                            let timeTop = timeTopCell ? timeTopCell.top + topOffset : scheduleTop;
                            let timeBottom = timeBottomCell ? timeBottomCell.top + bottomOffset : scheduleBottom;

                            let overlayTop = timeTop < scheduleTop ? 0 : timeTop - scheduleTop -
                                parseInt(scheduleElement.css("border-top-width"));
                            let overlayHeight = (timeBottom > scheduleBottom ? scheduleBottom - scheduleTop - overlayTop :
                                timeBottom - overlayTop - scheduleTop) - parseInt(scheduleElement.css("border-bottom-width"));
                            let backgroundCss = !program.intersects && (!filteredProgramId || filteredProgramId == program.id) ?
                                `;background-color: ${program.backgroundOverlay}` : "";
                            let className = backgroundCss == "" ? "default" : "";

                            targetScheduleElements.push({
                                scheduleElement: scheduleElement, divDetailsHtml: service.GetHelperDiv(
                                    `scheduleYieldManagementOverlay ${className}`,
                                    program.id,
                                    "",
                                    `height:${overlayHeight}px;top:${overlayTop}px${backgroundCss}`
                                )
                            });
                        }
                    });
                };

                let scheduleIterator = (schedules, columnBooking, yieldManagementListResponse, targetScheduleElements) => {
                    schedules.forEach(schedule => {
                        if (!schedule.allowBooking) {
                            return;
                        }
                        let scheduleStartTime = moment(schedule.startTime, "H-m");
                        let scheduleEndTime = moment(schedule.endTime, "H-m");
                        schedule.startDateTime = moment(columnBooking.date).minutes(scheduleStartTime.minutes()).hours(scheduleStartTime.hours());
                        schedule.endDateTime = moment(columnBooking.date).minutes(scheduleEndTime.minutes()).hours(scheduleEndTime.hours());
                        let dateString = schedule.startDateTime.format(globals.columnDateFormat);
                        let scheduleElement = $(`#${helper.GetColumnId(dateString,
                            columnBooking.employeeId)}_${schedule.scheduleIndex}`);
                        scheduleElement.find(".scheduleYieldManagementOverlay").remove();

                        let programs = _(yieldManagementListResponse.data).filter(program => {
                            return program.employeeId === columnBooking.employeeId &&
                                moment(program.timeRange.startDateTime).format(globals.columnDateFormat) === dateString;
                        })
                        programIterator(programs, columnBooking, schedule, scheduleElement, targetScheduleElements);
                    });
                }

                let columnBookingIterator = (columnBookings, yieldManagementListResponse, targetScheduleElements) => {
                    columnBookings.forEach(columnBooking => {
                        scheduleIterator(columnBooking.schedules, columnBooking, yieldManagementListResponse, targetScheduleElements);
                    })
                }

                restServer.loadYieldManagementList(requestItems, filteredProgramId).then(yieldManagementListResponse => {
                    let targetScheduleElements = [];
                    columnBookingIterator(columnBookings, yieldManagementListResponse, targetScheduleElements);
                    targetScheduleElements.forEach(targetScheduleElement => {
                        targetScheduleElement.scheduleElement.append(targetScheduleElement.divDetailsHtml);
                    })
                });
            },
            writeMembershipIcons(response) {
                const clientIds = [];
                response.forEach(r => {
                    r.appointments.forEach(appointment => {
                        appointment.services.forEach(service => {
                            if (clientIds.indexOf(service.clientId) < 0) {
                                clientIds.push(service.clientId);
                            }
                        });
                    });
                });

                if (clientIds.length === 0) {
                    return;
                }

                restServer.LoadMembershipDetails(clientIds).then(res => {
                    response.forEach(r => {
                        r.appointments.forEach(appointment => {
                            appointment.services.forEach(serv => {
                                let clientMembership: any = _.findWhere(res.data, { clientId: serv.clientId });

                                if (!clientMembership || (!clientMembership.membershipIndicatorStatus && !clientMembership.clientMembershipIndicatorStatusEnum)
                                    || clientMembership.clientMembershipIndicatorEnum === undefined) {
                                    return;
                                }

                                const className = membershipDetailsService.getDetails(clientMembership, Meevo.Components.Common.MembershipDetailsPart.ClassName);
                                const iconFileName = membershipDetailsService.getDetails(clientMembership, Meevo.Components.Common.MembershipDetailsPart.IconFileName);
                                const displayName = membershipDetailsService.getDetails(clientMembership, Meevo.Components.Common.MembershipDetailsPart.DisplayName);

                                const indicatorHtml = `<md-icon class="${className} membershipIndicator" md-svg-icon="${iconFileName}" title="${displayName}"></md-icon>`;

                                $(`[data-id="${serv.id}"] #iconsContainer`).append($compile(indicatorHtml)($rootScope));
                                helper.updateAppointmentService(serv.id);
                            });
                        });
                    });
                });
            },
            writeBlocks(response) {
                //console.log('writeBlocks');
                //console.time('writeBlocks');

                response.forEach(r => {
                    if (r.blocks.length === 0) {
                        return;
                    }

                    //console.log(`writeBlocks (loop) ${columnId}`);
                    //console.time(`writeBlocks (loop) ${columnId}`);

                    const columnId = helper.GetColumnId(r.date, helper.getEntityId(r));
                    const column = _(globals.columnBookings).findWhere({ columnId: columnId });

                    if (!column) {
                        return;
                    }

                    const blocks = [];

                    for (let index = 0; index < r.blocks.length; index++) {
                        let block: Meevo.Plugins.AppointmentBook.Block = r.blocks[index];
                        column.appointmentsAndBlocks.push(block);

                        helper.expandBook(moment(block.startDateTime), moment(block.endDateTime));

                        let startDateTime = moment(block.startDateTime);
                        startDateTime.minutes(startDateTime.minutes() - (startDateTime.minutes() % $rootScope.appointmentBookIncrement));
                        let cell = helper.GetCellByIds(r.date, startDateTime.format('H-m'), helper.getEntityId(r));

                        // If block starts before book start time, display block at book start time
                        if (cell == null && moment(block.startDateTime).totalMinutes() < globals.bookStartTime.totalMinutes()) {
                            cell = helper.GetCellByIds(r.date, globals.bookStartTime.format('H-m'), helper.getEntityId(r));
                        }

                        if (cell == null) {
                            continue;
                        }

                        let totalMinutes = moment(block.endDateTime).diff(moment(block.startDateTime), 'm');

                        let height = helper.convertMinutesToPixels(totalMinutes);
                        let offSet = helper.getOffset(moment(block.startDateTime));
                        let top = cell.top + offSet;

                        let modBackColor = block.blockType.backgroundColorRgba
                            ? [block.blockType.backgroundColorRgba[0], block.blockType.backgroundColorRgba[1], block.blockType.backgroundColorRgba[2], .3]
                            : [255, 255, 255];

                        let blockText = ((block.displayReasonOnBook) ? block.reason : block.blockType.displayName) || $translate.instant('LABEL_BLOCK');

                        let backgroundColor = getRgbaColor(block.blockType.backgroundColorRgba);
                        let foregroundColor = getRgbaColor(block.blockType.foregroundColorRgba);
                        let content = `<div class="block-wrapper" style="border-color: ${backgroundColor};">`
                            + `<div class="block-wrapper-inner" style="color: ${foregroundColor};">${blockText}</div></div>`;

                        if (block.blockScheduleId) {
                            content += `<img class="blockDefIndicator" src="assets/images/appointmentBook/Appt_Standing_18.png" title="${$translate.instant('LABEL_BLOCK_PART_OF_SERIES')}" />`;
                        }

                        blocks.push(helper.GetDiv({
                            className: 'standardCell draggable block',
                            content: content,
                            data: ` data-type="${globals.blockDataTypeId}" data-ipb="${block.blockType.includeInPercentBooked}" data-m="${totalMinutes}" data-block-entity-version="${block.entityVersion}" data-id="${block.id}" data-height='${height}'`,
                            style: `height:${height}px;z-index:${globals.zIndexBooking};top:${top}px;width:${globals.columnWidth}px;color:${foregroundColor};background-color:${getRgbaColor(modBackColor)};padding:0 3px;`,
                        }));
                    }

                    if (blocks.length > 0) {
                        $(`#${columnId}`).append(blocks);
                    }
                });

                //console.timeEnd('writeBlocks');
            },
            writeAppointments(response) {
                //console.log('writeAppointments');
                //console.time('writeAppointments');

                const updates = [];

                response.forEach(r => {
                    if (r.appointments.length === 0) {
                        return;
                    }

                    const columnId = helper.GetColumnId(r.date, helper.getEntityId(r));
                    const column = _(globals.columnBookings).findWhere({ columnId: columnId });

                    if (!column) {
                        return;
                    }

                    const appointmentServices = [];

                    r.appointments.forEach((appointment: any) => {
                        for (let index = 0; index < appointment.services.length; index++) {
                            const appointmentService = appointment.services[index];

                            appointmentService.appointmentId = appointment.id;
                            column.appointmentServices.push(appointmentService);
                            column.appointmentsAndBlocks.push(appointmentService);

                            const appointmentServiceStartTime = moment(appointmentService.startDateTime);
                            helper.expandBook(moment(appointmentService.startDateTime), moment(appointmentService.startDateTime).add(appointmentService.totalMinutes, 'm'));

                            const clampedDate = clampDateToInterval(appointmentServiceStartTime, $rootScope.appointmentBookIncrement);

                            let cell = helper.GetCellByIds(r.date, clampedDate.format('H-m'), helper.getEntityId(r));
                            let offSet = helper.getOffset(moment(appointmentService.startDateTime));
                            // If appointment starts before book start time, display appointment at book start time
                            if (cell == null && appointmentServiceStartTime.totalMinutes() < globals.bookStartTime.totalMinutes()) {
                                cell = helper.GetCellByIds(r.date, globals.bookStartTime.format('H-m'), helper.getEntityId(r));
                            }

                            if (cell == null) {
                                return;
                            }

                            let html = helper.getAppointmentServiceWithData(appointmentService, appointment, null, cell.top + offSet);
                            appointmentServices.push(html);
                            updates.push({ appointmentService, appointment });
                        }
                    });

                    if (appointmentServices.length > 0) {
                        $(`#${columnId}`).append(appointmentServices);
                    }
                });

                $timeout(() => {
                    updates.forEach((update: any) => {
                        helper.updateAppointmentService(update.appointmentService.id, update.appointmentService, update.appointment);

                        helper.WireUpClientTypeClicking(
                            update.appointmentService.id,
                            update.appointmentService.clientTypeColor,
                            update.appointmentService.clientTypeId,
                            update.appointmentService.clientTypeDisplayName
                        );
                    });
                });

                //console.timeEnd(`writeAppointments`);
            },

            writeSchedulesEvents(r) {
                service.eventData = [];

                $.each(service.events, (index, event) => {
                    if (moment(r.date).diff(moment(event.startDateTime).startOf('day'), 'day') == 0) {
                        helper.expandBook(moment(event.startDateTime), moment(event.endDateTime));
                        const topCell = helper.GetCellByIds(r.date, moment(event.startDateTime).format('H-m'), helper.getEntityId(r));
                        const bottomCell = helper.GetCellByIds(r.date, moment(event.endDateTime).format('H-m'), helper.getEntityId(r));

                        const newEventData: any = {
                            eventName: event.displayName,
                            eventDate: event.startDateTime
                        };

                        if (topCell || bottomCell) {
                            newEventData.top = topCell ? topCell.top : 0;
                            newEventData.bottom = bottomCell ? bottomCell.top : $('#divTimeContainer').height();
                            newEventData['height'] = newEventData.bottom - newEventData.top;
                            service.eventData.push(newEventData);
                        }
                    }
                });

                service.eventData.sort((a, b) => {
                    return a['top'] - b['top'];
                });
            },
            writeSchedulesColumn(r, columnId, column) {
                lastScheduleBottom = 0;
                column.bookableMinutes = 0;
                column.schedules = r.schedules;

                const bookableSchedules = _.filter(r.schedules, (schedule: any) => schedule.workType.isBookableTime || schedule.workType.showOnBook);
                _.forEach(bookableSchedules, (schedule: any) => helper.expandBook(moment(schedule.startTime, 'H-m'), moment(schedule.endTime, 'H-m')));

                const apptsConflict = [];

                $(`#${columnId} > .appointment, #${columnId} > .block`).each(function () {
                    apptsConflict.push({
                        top: parseInt(this.style.top),
                        height: $(this)[0].getBoundingClientRect().height
                    });
                });

                apptsConflict.sort((a, b) => {
                    const n = a['top'] - b['top'];
                    return (n !== 0) ? n : b['height'] - a['height'];
                });

                let isColumnBookable = false;
                for (let scheduleIndex = 0; scheduleIndex < r.schedules.length; scheduleIndex++) {
                    if ((r.schedules[scheduleIndex].workType.showOnBook && r.schedules[scheduleIndex].workType.isBookableTime) ||
                        (r.schedules[scheduleIndex].workType.showOnBook && r.schedules[scheduleIndex].workType.isBookableTime && r.schedules[scheduleIndex].workType.showApptText) ||
                        (r.schedules[scheduleIndex].workType.showOnBook) ||
                        (r.schedules[scheduleIndex].workType.showOnBook && r.schedules[scheduleIndex].workType.showApptText)) {
                        isColumnBookable = true;
                        break;
                    }
                }

                let height = 0;
                let html = [];
                let htmlEvents: any = {};
                let htmlContainers: any = {};

                for (let scheduleIndex = 0; scheduleIndex < r.schedules.length; scheduleIndex++) {
                    service.writeSchedulesItem(r, html, htmlEvents, htmlContainers, apptsConflict, column, columnId, scheduleIndex, height, isColumnBookable);
                }

                if (html.length > 0) {
                    $(`#${columnId}`).append(html);
                }

                for (let key in htmlEvents) {
                    $(key).append(htmlEvents[key]);
                }

                for (let key in htmlContainers) {
                    $(key).append(htmlContainers[key]);
                }
            },
            writeSchedulesItem(r, html, htmlEvents, htmlContainers, apptsConflict, column, columnId, scheduleIndex, height, isColumnBookable) {
                const schedule = r.schedules[scheduleIndex];
                schedule.scheduleIndex = scheduleIndex;

                if (schedule.endTime == '0-0') {
                    schedule.endTime = '23-59';
                }

                if (schedule.workType.isBookableTime) {
                    column.bookableMinutes += schedule.totalMinutes;
                }

                let endOffset = 0;
                let startTime = moment(schedule.startTime, 'H-m');
                startTime.minutes(startTime.minutes() - (startTime.minutes() % $rootScope.appointmentBookIncrement));
                let startCell = helper.GetCellByIds(r.date, startTime.format('H-m'), helper.getEntityId(r));
                let endCell;
                let columnWidth = helper.GetColumnWidth(column);

                if (schedule.endTime != undefined) {
                    let endTime = moment(schedule.endTime, 'H-m');
                    endTime.minutes(endTime.minutes() - (endTime.minutes() % $rootScope.appointmentBookIncrement));
                    endCell = helper.GetCellByIds(r.date, endTime.format('H-m'), helper.getEntityId(r));
                    endOffset += helper.getOffset(moment(schedule.endTime, 'H-m'));
                }

                if (startCell != null) {
                    height = helper.convertMinutesToPixels(schedule.totalMinutes);
                } else if (endCell != null) {
                    height = endCell.top;
                    height += endOffset;
                } else if (moment(schedule.startTime, 'H-m').totalMinutes() < globals.bookStartTime.totalMinutes() &&
                    moment(schedule.endTime, 'H-m').totalMinutes() >= globals.bookEndTime.totalMinutes()) {
                    // time spans entire range displayed in book
                    // this should only happen with non-bookable time
                    let totalMinutes = (24 * 60) - globals.bookStartTime.totalMinutes();
                    height = helper.convertMinutesToPixels(totalMinutes);
                } else {
                    // time entirely before or after the range displayed in book
                    // this should only happen with non-bookable time
                    return;
                }

                let scheduleId = columnId + '_' + scheduleIndex;
                if (startCell != null && endCell == null) {
                    helper.lastScheduleIds.push(scheduleId);
                    height = $('#divTimeContainer').height() - startCell.top;
                }

                let backColor = schedule.workType.style.backgroundColorRgba.slice();
                let foreColor = schedule.workType.style.foregroundColorRgba.slice();
                let borderColor = schedule.workType.style.backgroundColorRgba.slice();

                if (schedule.workType.showOnBook) {
                    if (backColor && backColor[3] == 1) {
                        backColor[3] = schedule.workType.isBookableTime ? 0 : 1;
                    }
                } else {
                    backColor[3] = 0.6;
                }

                foreColor = schedule.workType.style.foregroundColorRgba.slice();

                let displayName = schedule.description.escapeHtml();
                if (isColumnBookable && schedule.workType.showApptText && schedule.workType.showOnBook || !schedule.workType.showApptText) {
                    // US-10943 Scenario 3 we dont need to show text.
                    displayName = '';
                }

                if (schedule.workType.isBookableTime) {
                    // Don't need to display anything for bookable schedules
                    // create div for bookable time schedules (Available)
                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        scheduleId,
                        isColumnBookable ? displayName : '',
                        `height:${height}px;width:${columnWidth}px;color:${getRgbaColor(foreColor)};background-color:${getRgbaColor(backColor)};border:4px solid rgba(${borderColor});border-left:3px solid rgba(${borderColor});`,
                    ));

                    if (service.eventData && service.eventData.length > 0) {
                        // Create div for events color
                        htmlEvents[`#${scheduleId}_events`] = [];

                        let eventBgMargin = 0;

                        $.each(service.eventData, (index, evnt) => {
                            eventBgMargin = index == 0
                                ? evnt.top - startCell.top
                                : evnt.top - startCell.top - eventBgMargin;

                            htmlEvents[`#${scheduleId}_events`].push(
                                service.GetHelperDiv(
                                    'standardCellRel mv-schedules workActivityLabel eventsBg',
                                    `${scheduleId}_events_${index}`,
                                    '',
                                    `height:${evnt.height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:black;background-color:rgba(189,224,223,0.5);margin-top:${eventBgMargin}px;`,
                                ));

                            eventBgMargin += evnt.height;
                        });

                        html.push(service.GetHelperDiv(
                            'standardCellRel mv-schedules workActivityLabel eventsBg',
                            `${scheduleId}_events`,
                            isColumnBookable ? displayName : '',
                            `height:${height}px;width:${columnWidth}px;z-index:1;color:${getRgbaColor(foreColor)};background-color:${getRgbaColor(backColor)};margin-top:-${height}px;`,
                        ));
                    }

                    // create border div for bookable time schedules (Available) US-10943 Scenario 1,2
                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityIntersectionBorder workActivityLabel',
                        `border_${scheduleId}`,
                        isColumnBookable ? displayName : '',
                        `height:${height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule + 4};margin-top:-${height}px;border-color:rgba(${borderColor})`,
                    ));
                } else {
                    // create div for non-bookable time schedules (Off) or US-10943 Scenario 5,4,3
                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        scheduleId,
                        isColumnBookable ? displayName : '',
                        `height:${height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};background-color:${getRgbaColor(backColor)};line-height:${height}px;`,
                    ));

                    let heightDiff = 0;
                    let lastMvSchedules = undefined;

                    if (scheduleIndex == r.schedules.length - 1) {
                        $('.column').each((index, column) => {
                            if ($(column).attr('id') != columnId) {
                                heightDiff = $('#divTimeContainer').height() - $(column).height();
                                if ($('#' + $(column).attr('id') + '_labels').height() < $('#' + columnId + '_labels').height()) {
                                    $('#' + $(column).attr('id') + '_labels').height($('#' + columnId + '_labels').height());
                                    lastMvSchedules = $(column).children('.mv-schedules').last();
                                    if ($(column).children('.mv-schedules').length > 3) {
                                        lastMvSchedules.css('height', '+=' + heightDiff);
                                        lastMvSchedules.css('line-height', lastMvSchedules.css('height'));
                                    }
                                    lastMvSchedules.children().last().css('height', '+=' + heightDiff);
                                    lastMvSchedules.children().last().css('line-height', lastMvSchedules.children().last().css('height'));
                                }
                            }
                        });
                    }
                }

                if (scheduleIndex == 0 && r.schedules.length == 1) {
                    let height = $('#divTimeContainer').height();
                    // create parent div for all the Off labels. Only one div.
                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        columnId + '_labels',
                        ((apptsConflict.length == 0 && !isColumnBookable) ? schedule.description.escapeHtml() : ''),
                        `height:${height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule + 1};color:${getRgbaColor(foreColor)};line-height:${height}px;position:absolute;top:0`,
                    ));
                }

                if (isColumnBookable && schedule.workType.isBookableTime && schedule.workType.showOnBook) {
                    // US-10943 Scenario 1 and 2
                    htmlContainers['#' + scheduleId] = service.writeScheduleLabels(
                        startCell,
                        height,
                        columnId,
                        (schedule.workType.showApptText) ? schedule.description.escapeHtml() : '',
                        scheduleId,
                        schedule.workType.showApptText,
                        foreColor,
                        column,
                        true,
                        schedule.workType.isBookableTime
                    );
                } else if (isColumnBookable && schedule.workType.showApptText && schedule.workType.showOnBook) {
                    // US-10943 Scenario 4
                    if (!schedule.workType.isBookableTime) {
                        htmlContainers['#' + scheduleId] = service.writeScheduleDivs(
                            height,
                            apptsConflict.slice(),
                            schedule.description.escapeHtml(),
                            scheduleId,
                            false,
                            foreColor,
                            column,
                            false,
                            schedule.workType.isBookableTime
                        );
                    } else {
                        htmlContainers['#' + scheduleId] = service.writeScheduleLabels(
                            startCell,
                            height,
                            columnId,
                            schedule.description.escapeHtml(),
                            scheduleId,
                            false,
                            foreColor,
                            column,
                            false,
                            schedule.workType.isBookableTime
                        );
                    }
                } else if (isColumnBookable && !schedule.workType.isBookableTime && !schedule.workType.showOnBook) {
                    // US-10943 Scenario 5
                    htmlContainers['#' + scheduleId] = service.writeScheduleLabels(
                        startCell,
                        height,
                        columnId,
                        schedule.description.escapeHtml(),
                        scheduleId,
                        false,
                        foreColor,
                        column,
                        false,
                        schedule.workType.isBookableTime
                    );
                } else if (schedule.description.toLowerCase() != 'off' && column.incrementMaskingText != '' && column.maskingIncrement > 0) {
                    // because we don't want to see AVAILBALE/OFF.
                    htmlContainers['#' + scheduleId] = service.writeScheduleLabels(
                        startCell,
                        height,
                        columnId,
                        '',
                        scheduleId,
                        false,
                        foreColor,
                        column,
                        false,
                        schedule.workType.isBookableTime
                    );
                } else if (!isColumnBookable && apptsConflict.length > 0 && r.schedules.length > 1) {
                    htmlContainers['#' + scheduleId] = service.writeScheduleLabels(
                        startCell,
                        height,
                        columnId,
                        (schedule.workType.showApptText || schedule.description.escapeHtml().toLowerCase() == 'off') ? schedule.description.escapeHtml() : '',
                        scheduleId,
                        false,
                        foreColor,
                        column,
                        false,
                        schedule.workType.isBookableTime
                    );
                }

                lastScheduleBottom += height;

                if (!isColumnBookable && apptsConflict.length > 0 && r.schedules.length === 1) {
                    // if column have no schedules and at least one appointment or block.
                    let lastTop = 0;
                    let newHeight = 0;
                    let appointments = jQuery.extend(true, [], apptsConflict);

                    for (let appointmentIndex = 0; appointmentIndex < appointments.length + 1; appointmentIndex++) {
                        if (appointmentIndex > 0 && appointments[appointmentIndex] && appointments[appointmentIndex].top >= appointments[appointmentIndex - 1].top && (appointments[appointmentIndex].top + appointments[appointmentIndex].height) <= (appointments[appointmentIndex - 1].top + appointments[appointmentIndex - 1].height)) {
                            appointments[appointmentIndex] = appointments[appointmentIndex - 1];
                            continue;
                        }

                        newHeight = appointments[appointmentIndex]
                            ? appointments[appointmentIndex].top - lastTop
                            : $('#divTimeContainer').height() - lastTop;

                        if (newHeight <= 0) {
                            if (appointmentIndex > 0 && appointments[appointmentIndex] && (appointments[appointmentIndex].top + appointments[appointmentIndex].height) > (appointments[appointmentIndex - 1].top + appointments[appointmentIndex - 1].height)) {
                                lastTop = appointments[appointmentIndex].top + appointments[appointmentIndex].height;
                            }
                            continue;
                        }

                        // create div for columns without schedules or US-10943 Scenario 5.
                        html.push(service.GetHelperDiv(
                            'standardCellRel mv-schedules workActivityLabel',
                            columnId + '_label' + appointmentIndex,
                            schedule.description.escapeHtml(),
                            `height:${newHeight}px;width:${columnWidth};z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${newHeight}px;position:absolute;top:${lastTop}px;`,
                        ));

                        if (appointments[appointmentIndex]) {
                            lastTop = appointments[appointmentIndex].top + appointments[appointmentIndex].height;
                        }
                    }
                }
            },
            writeSchedules(response) {
                //console.log('writeSchedules');
                //console.time('writeSchedules');

                const columnIds = [];

                response.forEach(r => {
                    const columnId = helper.GetColumnId(r.date, helper.getEntityId(r));

                    //console.log(`writeSchedules (loop) ${columnId}`);
                    //console.time(`writeSchedules (loop) ${columnId}`);

                    columnIds.push(columnId);

                    $(`#${columnId} > .mv-schedules`).remove();

                    service.writeSchedulesEvents(r);

                    const column = _(globals.columnBookings).findWhere({ columnId: columnId });
                    if (column) {
                        service.writeSchedulesColumn(r, columnId, column);
                    }

                    //console.timeEnd(`writeSchedules (loop) ${columnId}`);
                });

                //console.timeEnd('writeSchedules');
                service.writeScheduleTimeClockActions(response, true).then(() => {
                    service.writeYieldManagementPrograms(response, (globals.opacityFilterSelections || {}).programId);
                })
                return columnIds;
            },
            writeScheduleDivs(height, appointments, displayName, containerId, showTextInEachCell, foreColor, column, showEvents, isBookableTime) {
                const currentScheduleTop = lastScheduleBottom;
                const currentScheduleBottom = currentScheduleTop + height;
                const currentScheduleAppointments = appointments.filter(appt => {
                    const apptBottom = appt.top + appt.height;
                    return (appt.top >= currentScheduleTop && appt.top <= currentScheduleBottom)
                        || (apptBottom >= currentScheduleTop && apptBottom <= currentScheduleBottom);
                });
                const lastAppointmentBottom = currentScheduleAppointments.length > 0 ?
                    currentScheduleAppointments[currentScheduleAppointments.length - 1].top + currentScheduleAppointments[currentScheduleAppointments.length - 1].height
                    : 0;
                const columnWidth = helper.GetColumnWidth(column);

                const html = [];

                let divId = 0;
                for (let idx = 0; idx < currentScheduleAppointments.length; idx++) {

                    // first appointment or block is later than the start of the current schedule
                    if (idx === 0 && currentScheduleAppointments[0].top > currentScheduleTop) {
                        const firstDivHeight = currentScheduleAppointments[0].top - currentScheduleTop;
                        html.push(service.GetHelperDiv(
                            'standardCellRel mv-schedules workActivityLabel',
                            containerId + `_${divId++}`,
                            displayName,
                            `height:${firstDivHeight}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${firstDivHeight}px;position: absolute; border-bottom-color: transparent;`,
                        ));
                    }

                    const currentAppointment = currentScheduleAppointments[idx];
                    const scheduleDivTop = currentAppointment.top + currentAppointment.height;
                    const scheduleDivBottom = idx + 1 === currentScheduleAppointments.length ? currentScheduleBottom : currentScheduleAppointments[idx + 1].top;
                    const scheduleDivHeight = scheduleDivBottom - scheduleDivTop;

                    if (scheduleDivHeight < 1) {
                        continue;
                    }

                    const divTopPosition = scheduleDivTop - currentScheduleTop;

                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        containerId + `_${divId++}`,
                        displayName,
                        `height:${scheduleDivHeight}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${scheduleDivHeight}px;top:${divTopPosition}px;position: absolute; border-top-color: transparent; border-bottom-color: transparent;`,
                    ));
                }

                const scheduleDivHeight = lastAppointmentBottom === 0 ? currentScheduleBottom - currentScheduleTop : currentScheduleBottom - lastAppointmentBottom;
                if (scheduleDivHeight < 1) {
                    return html.join('');
                }

                const divTopPosition = lastAppointmentBottom;
                const id = divId || 0;
                const border = divId > 0 ? 'border-top-color:transparent;' : '';
                html.push(service.GetHelperDiv(
                    'standardCellRel mv-schedules workActivityLabel',
                    containerId + '_' + id,
                    displayName,
                    `height:${scheduleDivHeight}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${scheduleDivHeight}px;top:${divTopPosition}px;position: absolute; ${border}`,
                ));

                return html.join('');
            },
            writeScheduleLabels(startCell, height, columnId, displayName, containerId, showTextInEachCell, foreColor, column, showEvents, isBookableTime) {
                //console.log('writeSchedulesLabels');
                //console.time('writeSchedulesLabels');

                if (!startCell) {
                    startCell = { top: 0, left: 0 };
                }

                if (showEvents && !showTextInEachCell) {
                    displayName = '';
                    showTextInEachCell = true;
                }

                const stepsAndBlocks = [];
                const getElementPositionData = (element, isStep = true, isGap = false) => {
                    return {
                        top: isStep ? parseFloat($($(element).parent())[0].style.top) + $(element).position().top : parseFloat(element.style.top),
                        height: $(element)[0].getBoundingClientRect().height,
                        isGap: isGap,
                        get bottom() {
                            return this.top + this.height;
                        }
                    }
                }
                $(`#${columnId} > .appointment > .nongap`).each(function() {
                    stepsAndBlocks.push(getElementPositionData(this));
                });

                $(`#${columnId} > .appointment > .gap`).each(function() {
                    stepsAndBlocks.push(getElementPositionData(this, true, true));
                });

                $(`#${columnId} > .block`).each(function() {
                    stepsAndBlocks.push(getElementPositionData(this, false));
                });

                stepsAndBlocks.sort((a, b) => {
                    const n = a['top'] - b['top'];
                    return (n !== 0) ? n : b['height'] - a['height'];
                });

                $.each(stepsAndBlocks, (index, obj: any) => {
                    if (obj.top + obj.height < startCell.top) {
                        stepsAndBlocks.slice(index, 1);
                    }
                    if (obj.top > startCell.top + height) {
                        stepsAndBlocks.slice(index, 1);
                    }
                });

                let display = '';
                let originalDisplayName = displayName;
                let marginBlock = 0;
                let scheduleDiv = { top: null, height: null };
                let lastTop;
                let showMaskText = isBookableTime && (column.incrementMaskingText != '' && column.maskingIncrement > 0);
                let showMaskTextOnCell = 0;
                let columnWidth = helper.GetColumnWidth(column);
                let nextMaskLabelRowIndex = null;
                let lastRowWasEmpty = false;

                const getNextMaskLabelRowIndex = (rowIndex: number) => {
                    return rowIndex + column.maskingIncrement / this.$rootScope.appointmentBookIncrement;
                }

                if (originalDisplayName.toLowerCase() != 'off' && showMaskText && column.maskingIncrement == this.$rootScope.appointmentBookIncrement) {
                    showTextInEachCell = true;
                }

                let htmlContainer = [];

                let divRows = $('.row');
                for (let rowIndex = 0; rowIndex < divRows.length; rowIndex++) {
                    let rowTop = $(divRows[rowIndex]).position().top;
                    if (rowTop < startCell.top || rowTop >= startCell.top + height) {
                        continue;
                    }

                    lastTop = rowTop;

                    let eventObj = null;

                    if (showEvents) {
                        let eventCounter = 0;
                        while (service.eventData.length > eventCounter) {
                            if (rowTop >= service.eventData[eventCounter].top &&
                                rowTop < service.eventData[eventCounter].bottom) {
                                eventObj = service.eventData[eventCounter];
                                break;
                            } else if (rowTop < service.eventData[eventCounter].top) {
                                eventObj = null;
                                break;
                            } else {
                                eventCounter++;
                            }
                        }
                        if (showEvents && service.eventData.length <= eventCounter) {
                            eventObj = null;
                        }
                    }

                    let sliceIndex = stepsAndBlocks.length;
                    let rowHasServicingSlice = false;
                    const stepsAndBlocksOnRow = stepsAndBlocks.filter(slice => {
                        var isTopEffectivelyEqualToRowTop = Math.abs(slice.top - rowTop) <= globals.overlapTolerance;
                        var isBottomEffectivelyEqualToRowTop = Math.abs(slice.bottom - rowTop) <= globals.overlapTolerance;
                        var sliceIsInRow = (isTopEffectivelyEqualToRowTop || slice.top <= rowTop) &&
                            !isBottomEffectivelyEqualToRowTop && slice.bottom > rowTop;

                        if (sliceIsInRow) {
                            rowHasServicingSlice = rowHasServicingSlice || !slice.isGap;
                        }

                        return sliceIsInRow;
                    });

                    if (stepsAndBlocksOnRow.length > 0) {

                        const showMaskLabelInGap = showMaskText && !rowHasServicingSlice &&
                            (!lastRowWasEmpty || !nextMaskLabelRowIndex || rowIndex === nextMaskLabelRowIndex);

                        sliceIndex = stepsAndBlocks.indexOf(stepsAndBlocksOnRow[0]);

                        if (!showMaskLabelInGap && showTextInEachCell) {
                            display += `<div style="height:${globals.cellHeight}px"></div>`;
                        } else if (showMaskLabelInGap) {
                            display += `<div style="height:${globals.cellHeight}px">${column.incrementMaskingText}</div>`;
                            nextMaskLabelRowIndex = getNextMaskLabelRowIndex(rowIndex);
                        } else {
                            if (scheduleDiv.top != null) {
                                scheduleDiv.height = rowTop - scheduleDiv.top;

                                globals.lastAppointmentHeight = scheduleDiv.height;
                                // create div to show labels vertically middle of between all the appointments/blocks.
                                htmlContainer.push(this.createAvailableDivWithMasking(
                                    scheduleDiv.height,
                                    containerId + '_' + sliceIndex,
                                    displayName,
                                    foreColor,
                                    column,
                                    showMaskText,
                                    marginBlock
                                ));

                                scheduleDiv = { top: null, height: null };

                                marginBlock = 0;
                            }
                            marginBlock += globals.cellHeight;
                        }
                        if (!nextMaskLabelRowIndex || nextMaskLabelRowIndex <= rowIndex) {
                            nextMaskLabelRowIndex = getNextMaskLabelRowIndex(rowIndex);
                        }
                        showMaskTextOnCell = rowTop;
                    }

                    lastRowWasEmpty = !rowHasServicingSlice;

                    if (showEvents) {
                        if (eventObj && eventObj.eventName) {
                            displayName = eventObj.eventName;
                        } else if (!eventObj) {
                            displayName = originalDisplayName;
                        }
                    }

                    if (sliceIndex == stepsAndBlocks.length) {
                        if (showMaskText && showMaskTextOnCell <= rowTop) {
                            display += `<div style="height:${globals.cellHeight}px">${column.incrementMaskingText}</div>`;
                            nextMaskLabelRowIndex = getNextMaskLabelRowIndex(rowIndex);
                            // if next display row doesn't exist so make the position the bottom of last row so nothing else gets written
                            showMaskTextOnCell = nextMaskLabelRowIndex < divRows.length ? $(divRows[nextMaskLabelRowIndex]).position().top :
                                ($(divRows[divRows.length - 1]).position().top + $(divRows[divRows.length - 1]).outerHeight());
                            if (scheduleDiv.top == null) {
                                scheduleDiv.top = rowTop;
                            }
                        } else if (showTextInEachCell) {
                            display += `<div style="height:${globals.cellHeight}px">${displayName}</div>`;
                        } else if (scheduleDiv.top == null) {
                            scheduleDiv.top = rowTop;
                        }
                    }
                }

                if (showTextInEachCell) {
                    // create a div to show label in each cell of schedule.
                    htmlContainer.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        containerId + '_0',
                        display,
                        `height:${height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${globals.cellHeight}px;margin-top:-4px;`,
                    ));
                } else {
                    if (scheduleDiv.top == null) {
                        return htmlContainer;
                    }
                    if (scheduleDiv.height == null) {
                        scheduleDiv.height = lastTop - scheduleDiv.top + globals.cellHeight;
                    }

                    // create div to show labels vertically middle of between all the appointments/blocks.
                    if (displayName.toLowerCase() == 'off') {
                        htmlContainer.push(service.GetHelperDiv(
                            'mv-schedules workActivityLabel',
                            containerId + '_0',
                            displayName,
                            `height:${scheduleDiv.height}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${scheduleDiv.height}px;margin-top:${marginBlock}px;`,
                        ));
                    } else {
                        htmlContainer.push(this.createAvailableDivWithMasking(
                            scheduleDiv.height,
                            containerId + '_' + 0,
                            displayName,
                            foreColor,
                            column,
                            showMaskText,
                            marginBlock
                        ));
                    }
                }

                //console.timeEnd('writeSchedulesLabels');

                return htmlContainer;
            },
            createAvailableDivWithMasking(bookedAppointmentHeight, newId, displayName, foreColor, column, showMaskText, marginBlock) {
                //console.log('createAvailableDivWithMasking');
                //console.time('createAvailableDivWithMasking');

                let html = [];
                let columnWidth = helper.GetColumnWidth(column);

                if (!showMaskText) {
                    html.push(service.GetHelperDiv(
                        'standardCellRel mv-schedules workActivityLabel',
                        newId + '_0',
                        displayName,
                        `height:${bookedAppointmentHeight}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${bookedAppointmentHeight}px;margin-top:${marginBlock}px;`,
                    ));

                    return html.join('');
                }

                const x = 0;

                while (bookedAppointmentHeight > 0) {
                    //console.log('createAvailableDivWithMasking (loop)');
                    //console.time('createAvailableDivWithMasking (loop)');

                    if (globals.cellHeight <= bookedAppointmentHeight) {
                        html.push(service.GetHelperDiv(
                            'standardCellRel mv-schedules workActivityLabel',
                            newId + '_' + x,
                            column.incrementMaskingText,
                            `height:${globals.cellHeight}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${globals.cellHeight}px;margin-top:${marginBlock}px;border-bottom:0;`,
                        ));

                        marginBlock = 0;

                        bookedAppointmentHeight -= globals.cellHeight;
                    }

                    const maskingInPx = Math.min(((column.maskingIncrement / 15) - 1) * 35, bookedAppointmentHeight);
                    if (maskingInPx > 0 && bookedAppointmentHeight >= maskingInPx) {
                        html.push(service.GetHelperDiv(
                            'standardCellRel mv-schedules workActivityLabel',
                            newId + '_' + x,
                            displayName,
                            `height:${maskingInPx}px;width:${columnWidth}px;z-index:${globals.zIndexSchedule};color:${getRgbaColor(foreColor)};line-height:${maskingInPx}px;margin-top:0;border-bottom:0;`,
                        ));

                        bookedAppointmentHeight -= maskingInPx;
                    }

                    //console.timeEnd('createAvailableDivWithMasking (loop)');
                }

                //console.timeEnd('createAvailableDivWithMasking');

                return html.join('');
            },
            GetHelperDiv(className, id, displayName, style) {
                return helper.GetDiv({
                    id: id,
                    className: className,
                    content: displayName,
                    style: style,
                });
            },

            clearColumns(response) {
                response.forEach(responseColumn => {
                    const columnId = helper.GetColumnId(responseColumn.date, helper.getEntityId(responseColumn));
                    //console.log('clearColumns', columnId);
                    $(`#${columnId}`).empty();
                });
            },
            writeBookedPercentages(response) {
                response.forEach(responseColumn => {
                    const columnId = helper.GetColumnId(responseColumn.date, helper.getEntityId(responseColumn));
                    const column: any = _.findWhere(globals.columnBookings, { columnId: columnId });
                    if (column) {
                        helper.setColumnBookedPercentage(column, responseColumn.bookedPercentage || 0);
                    }
                });
            },
            writeParentColumnHeaders(parentDimension, level: number = 0) {
                if (level == 0) {
                    globals.dimensions = parentDimension.innerDimensions;
                }
                level++;

                //console.log(`writeParentColumnHeaders ${level}`)
                //console.time(`writeParentColumnHeaders ${level}`);

                let htmlColumns = [];
                let htmlLevels = [];
                let htmlId = {};
                let scrollToId;
                let innerDimensionFirst = null;
                let level2Css = level === 2 ? 'border-top: 1px solid black;' : '';

                for (let innerDimension of parentDimension.innerDimensions) {
                    let numberOfLeaves = service.getNumberOfLeaves(innerDimension, parentDimension);
                    if (numberOfLeaves === 0) {
                        continue;
                    }

                    if (innerDimensionFirst == null) {
                        innerDimensionFirst = innerDimension;
                    }

                    let levelId = 'divHeader' + level;
                    let divRootHeaders = $('#divRootHeaders');

                    if ($(`#${levelId}`).length === 0) {
                        divRootHeaders.append(`<div data-dimension-type="${innerDimensionFirst.dimensionType}" style="height:35px;top:${level * globals.constCellHeight}px;${level2Css}" id="${levelId}"></div>`);
                    }

                    innerDimension.uniqueId = NewGuid();

                    let dataAttr = ' ';
                    switch (innerDimension.dimensionType) {
                        case Meevo.Model.DimensionTypeEnum.Employee:
                            dataAttr += `data-employee-id="${innerDimension.employeeId}" `;
                            break;
                        case Meevo.Model.DimensionTypeEnum.Resource:
                            dataAttr += `data-resource-id="${innerDimension.resourceId}" `;
                            break;
                        case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                            dataAttr += `data-resource-id="${innerDimension.columnBooking.resourceId}" data-resource-unit-id="${innerDimension.columnBooking.resourceUnitId}" `;
                            break;
                    }

                    // Give each header cell a unique id b/c the id of the dimension isn't unique as the same item (resource for instance) could have multiple cells in the header (one for multiple days for instance)
                    dataAttr += `data-dimension-type="${innerDimension.dimensionType}" data-id="${innerDimension.uniqueId}"`;

                    let id;
                    let display;
                    let className;
                    let backgroundColor;
                    let expandCollapseHtml = '';

                    let isActualLeaf = (!globals.showLeaves && innerDimension.isLeafParent) || innerDimension.isLeaf;

                    let getScaleCss = (modelColumnWidthPercent: number) : string => {
                        let scale = "";
                        if (globals.columnWidthPercent < modelColumnWidthPercent) {
                            const headerWidth = (modelColumnWidthPercent / globals.columnWidthPercent) * 100;
                            const headerScale = (globals.columnWidthPercent / modelColumnWidthPercent) * 100;
                            scale = `width:${headerWidth}%;transform:scaleX(${headerScale}%);transform-origin:left;`;
                        }
                        return scale;
                    }
                    if (isActualLeaf) {
                        let columnBooking = innerDimension.columnBooking;

                        if (!globals.showLeaves && innerDimension.isLeafParent) {
                            columnBooking = innerDimension.innerDimensions[0].columnBooking;
                        }

                        id = `Header${columnBooking.columnId}`;

                        // If its a resource unit leaf with no siblings, hide text.  Just clearing text creates weird spacing issue but hiding it works
                        let resourceUnitLeafWithNoSiblings = innerDimension.isLeaf && innerDimension.dimensionType === Meevo.Model.DimensionTypeEnum.ResourceUnit && parentDimension.innerDimensions.length === 1;
                        //let displayTextVisibility = `style="display: inline-block;margin-left:25px;margin-right:25px;width: 100%;${resourceUnitLeafWithNoSiblings ? 'visibility:hidden;' : ''}" class="text-ellipsis"`;
                        let displayTextVisibility = `style="display: inline-block; overflow: hidden;width: 100%;${resourceUnitLeafWithNoSiblings ? 'visibility:hidden;' : ''}"`;

                        if (innerDimension.dimensionType === Meevo.Model.DimensionTypeEnum.Date) {
                            dataAttr += globals.isEmployeeView
                                ? `data-employee-id="${parentDimension.employeeId}" `
                                : `data-resource-id="${parentDimension.resourceId}" `;
                        }

                        let foregroundColorStyle = columnBooking.foregroundColor ? `color:${getRgbaColor(columnBooking.foregroundColor)}` : '';
                        let hoursPerformedInARow = Meevo.Model.Guard.isSomething(innerDimension.hoursPerformedInARow) ? innerDimension.hoursPerformedInARow : 0;
                        let hoursPerformedPerDay = Meevo.Model.Guard.isSomething(innerDimension.hoursPerformedPerDay) ? innerDimension.hoursPerformedPerDay : 0;
                        let restrictions = hoursPerformedInARow === 0 && hoursPerformedPerDay === 0
                            ? ''
                            : `&nbsp;&nbsp;(${innerDimension.hoursPerformedInARow}|${innerDimension.hoursPerformedPerDay})`;

                        let idSpan = `${id}_Span`;

                        const modelColumnWidthPercent = 40;
                        let scale = getScaleCss(modelColumnWidthPercent);

                        display = `<div class="headerBar"></div><div style="display:flex;justify-content:space-between;${scale}"><div style="flex:none;">${getGenderIconHtml(innerDimension)}</div><div id="${idSpan}" class="headerCellText" style="flex:auto;overflow:hidden;${foregroundColorStyle}"><span style="pointer-events:none;" ${displayTextVisibility}>${innerDimension.headerText}${restrictions}</span></div><div class="headerCellArrow" style="flex:none;"></div></div>`;

                        let fillColor = columnBooking.foregroundColor ? getRgbaColor(columnBooking.foregroundColor) : '#fff';
                        let arrowIcon = `<style>#${id} .st0 { fill:${fillColor}; }</style><md-icon style="pointer-events:none" md-svg-src="assets/images/appointmentBook/expand-collapse.svg" class="appt-book-small-icon" aria-hidden="true"></md-icon>`;
                        expandCollapseHtml = `<div id="btnExpandCollapse" style="display:none;">${arrowIcon}</div>`;
                        className = 'headerCell';
                        backgroundColor = columnBooking.backgroundColor;

                        htmlColumns.push(helper.GetDiv({
                            id: columnBooking.columnId,
                            className: 'column',
                            data: dataAttr,
                            style: `width:${globals.columnWidth}px;`,
                        }));

                        htmlId[`#${id}`] = $compile(expandCollapseHtml)($rootScope);
                    } else {
                        switch (innerDimension.dimensionType) {
                            case Meevo.Model.DimensionTypeEnum.Employee:
                                display = `<div style="display:flex;justify-content:space-between;"><div style="flex:none;">${getGenderIconHtml(innerDimension)}</div><div style="flex:auto;overflow:hidden;pointer-events:none;">${innerDimension.headerText}</div></div>`;
                                break;
                            default:
                                display = `<div style="pointer-events:none;">${innerDimension.headerText}</div>`;
                                break;
                        }
                        className = 'headerCellRoot';
                        id = `Cell${replaceAll(innerDimension.id, '/', '-')}`;
                    }

                    if (filterActions.scrollToCurrentDate &&
                        innerDimension.dimensionType === Meevo.Model.DimensionTypeEnum.Date &&
                        innerDimension.isToday) {
                        scrollToId = id;
                    }
                    htmlLevels.push(helper.GetDiv({
                        id: id,
                        className: className,
                        content: display,
                        data: dataAttr,
                        style: `width:${globals.columnWidth * numberOfLeaves}px;background-color:${getRgbaColor(backgroundColor)};`,
                    }));

                    if (!isActualLeaf) {
                        service.writeParentColumnHeaders(innerDimension, level);

                        $timeout(() => {
                            if (globals.columnWidthPercent <= 70) {
                                let element = $(`#${id} > div`);
                                let className = `percent-${globals.columnWidthPercent >= 40 ? globals.columnWidthPercent : 40}`;
                                element.addClass(className);

                                let scale = getScaleCss(40);
                                if (scale !== "") {
                                    for (let cssPair of scale.split(";")) {
                                        element.css(cssPair.split(":")[0], cssPair.split(":")[1]);
                                    }
                                }
                            }
                        });
                    }
                }

                if (innerDimensionFirst) {
                    if (htmlColumns.length > 0) {
                        $('#divColumns').append(htmlColumns);
                    }

                    if (htmlLevels.length > 0) {
                        let levelId = 'divHeader' + level;
                        $(`#${levelId}`).append(htmlLevels);
                    }

                    if (scrollToId) {
                        globals.bookLastScrollXPosition = $(`#${scrollToId}`).position().left;
                    }
                    for (let key in htmlId) {
                        $(key + ' .headerCellArrow').append(htmlId[key]);
                    }

                    let potentialNewHeight = level * globals.constCellHeight;
                    let divRootHeaders = $('#divRootHeaders');
                    if (potentialNewHeight > divRootHeaders.height()) {
                        divRootHeaders.css('height', potentialNewHeight);
                    }
                }

                //console.timeEnd(`writeParentColumnHeaders ${level}`);
            },
            getNumberOfLeaves(column, parentDimension): number {
                let numberOfLeaves = 0;
                if (column.isLeaf) {
                    let bookingColumn;
                    switch (column.dimensionType) {
                        case Meevo.Model.DimensionTypeEnum.Employee:
                            bookingColumn = _(globals.columnBookings).findWhere({ employeeId: column.id, date: parentDimension.id });
                            break;

                        case Meevo.Model.DimensionTypeEnum.Date:
                            switch (parentDimension.dimensionType) {
                                case Meevo.Model.DimensionTypeEnum.Employee:
                                    bookingColumn = _(globals.columnBookings).findWhere({ date: column.id, employeeId: parentDimension.id });
                                    break;

                                case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                                    bookingColumn = _(globals.columnBookings).findWhere({ date: column.id, resourceUnitId: parentDimension.id });
                                    break;
                            }
                            break;

                        case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                            bookingColumn = _(globals.columnBookings).findWhere({ resourceUnitId: column.id, date: parentDimension.parentDimension.id });
                            break;
                    }
                    numberOfLeaves = bookingColumn ? 1 : 0;
                } else {
                    if (!globals.showLeaves && column.isLeafParent) {
                        // for resources, check if columnBooking exists for that resourceId
                        if (column.dimensionType === Meevo.Model.DimensionTypeEnum.Resource) {
                            const bookingColumn = _(globals.columnBookings).findWhere({ resourceId: column.id, date: parentDimension.id });
                            numberOfLeaves = bookingColumn ? 1 : 0;
                        } else {
                            numberOfLeaves = 1;
                        }
                    } else {
                        for (let childColumn of column.innerDimensions) {
                            numberOfLeaves += service.getNumberOfLeaves(childColumn, column);
                        }
                    }
                }
                return numberOfLeaves;
            },
            updatePages() {
                const pages = [];
                const pagesBefore = [];
                for (let i = 1; i <= 4; i++) {
                    if (globals.currentPage - i > 0) {
                        pagesBefore.push(globals.currentPage - i);
                    }
                }
                const pagesAfter = [];
                for (let i = 1; i <= 4; i++) {
                    if (globals.currentPage + i <= globals.totalPages) {
                        pagesAfter.push(globals.currentPage + i);
                    }
                }
                pages.push(globals.currentPage);
                for (let i = 1; i <= 4; i++) {
                    if (pages.length == 5) {
                        continue;
                    }
                    if (pagesBefore.length >= i) {
                        pages.push(pagesBefore[i - 1]);
                    }
                    if (pages.length == 5) {
                        continue;
                    }
                    if (pagesAfter.length >= i) {
                        pages.push(pagesAfter[i - 1]);
                    }
                }
                globals.pages = _(pages).sortBy((num) => num);
            },
            gotoCurrentPage() {
                helper.clearBook();
                shouldScrollTimebarIntoView = true;
                // Since scroll to current date capability entails switching to the page that has the current date, disable this feature when manually moving to a page
                filterActions.scrollToCurrentDate = false;
                service.WriteStructure(structureResponse);
                helper.postLoadCounts();
            },
            WriteStructure(response) {
                structureResponse = response;
                globals.timeColumnWidth = helper.isCellCountVisible() ? globals.timeCellWidth + globals.countWidth : globals.timeCellWidth;
                isPaused = false;
                globals.totalColumnBookings = [];
                helper.lastScheduleIds = [];
                /*
                // if current selection is week, server returning 1 day for the week should not affect that choice

                if (response.innerDimensions.length > 0) {
                    //07.28.2016 - Change the day/week view as per the data (date columns) coming from the server.
                    if (response.innerDimensions.length > 1) {
                        filterActions.selectWeek(false, true);
                    } else {
                        filterActions.selectDay(false, true);
                    }
                }
                */
                service.buildColumns(response);
                globals.totalPages = Math.ceil(globals.totalColumnBookings.length / globals.pageSize);
                service.setColumnBookings();

                service.updatePages();

                globals.disableDateChange = makeDimensionDataRequest();

                setHours(response);
                globals.scrollContainer.scrollLeft(0);

                service.writeParentColumnHeaders(response);

                service.postStructure();
                if ($('#appt-book-pager>div:first-child').width() != null) {
                    $('#appt-book-pager').width($('#appt-book-pager>div:first-child').width());
                } else {
                    $('#appt-book-pager').width('270px');
                }
                resizeContainer();
            },
            setColumnBookings() {
                globals.columnBookings = [];
                setCurrentPage();
                const offSet = (globals.currentPage - 1) * globals.pageSize;
                for (let i = 0; i < globals.pageSize; i++) {
                    const actualIndex = offSet + i;
                    if (globals.totalColumnBookings.length - 1 >= actualIndex) {
                        globals.columnBookings.push(globals.totalColumnBookings[actualIndex]);
                    }
                }
            },
            postStructure() {
                // Wanted to dynamically use outerHeight but sometimes that returns null probably b/c its a directive and angular hasn't processed it yet
                globals.headerMargin = globals.filterBarHeight; // $("#divApptBookHeader").outerHeight();
                globals.headerOffset = $('#divRootHeaders').height() + globals.headerMargin;
                globals.containerOffset = $('#content').offset().top;

                var divTimeContainer = $('#divTimeContainer');
                var divTimeContainerRight = $('#divTimeContainerRight');

                let modalWidth = actions.GetOpenModalWidth();

                $('.standardCellTopLeft').css({ "height": globals.headerOffset - globals.headerMargin, "top": globals.headerMargin + globals.containerOffset, "width": globals.timeColumnWidth });
                $('.standardCellTopRight').css({ "height": globals.headerOffset - globals.headerMargin, "top": globals.headerMargin + globals.containerOffset, "width": modalWidth - globals.timeColumnWidth });

                globals.columnRight = globals.timeColumnWidth + (globals.columnBookings.length * globals.columnWidth);

                service.SetupDivs();

                var intervals = helper.writeTimeStructure(globals.bookStartTime, globals.bookEndTime);
                var columnBottom = (intervals) * globals.cellHeight;
                service.WireUpEmptyCellClick(globals.columnRight, columnBottom);

                $('#timeContainerLeft').css({ "margin-top": globals.headerOffset, "width": globals.timeColumnWidth, "z-index": globals.zIndexTime, "height": 'calc(100% - ' + globals.headerOffset + 'px)' });
                $('#timeContainerRight').css({ "margin-top": globals.headerOffset, "width": globals.timeColumnWidth, "z-index": globals.zIndexTime, "height": 'calc(100% - ' + globals.headerOffset + 'px)' });
                divTimeContainer.css({ "width": globals.timeColumnWidth, "z-index": globals.zIndexTime });
                divTimeContainerRight.css({ "width": globals.timeColumnWidth, "z-index": globals.zIndexTime });
                $('#divRootHeaders').css('margin-left', globals.timeColumnWidth).css('top', globals.headerMargin + globals.containerOffset);

                if ($('#divColumns').width() > $('#divAppointmentBookScrollContainer').width()) {
                    $('#divRootHeaders').css('width', $('#divAppointmentBookScrollContainer').width()).css('overflow', 'hidden');
                }
                else {
                    $('#divRootHeaders').css('overflow', 'visible');
                }
                $('#divAppointmentBookScrollContainer').css({ left: globals.timeColumnWidth, top: globals.headerOffset, height: 'calc(100% - ' + globals.headerOffset + 'px)' });
                $('#divAppointmentBookFillContainer').css('padding-left', globals.timeColumnWidth);
                actions.CheckForAdjustEditor();
                $('#divRows').css('width', globals.columnRight - globals.timeColumnWidth);
                $('#divCurrentTimeBar').css('height', globals.cellHeight);
                $('#divCutCopy').css('top', globals.headerMargin + globals.containerOffset);
            },
            SetupDivs() {
                globals.divNewBooking = $('#divNewBooking').css('z-index', globals.zIndexPopup);
                globals.divAppointmentDetails = $('.divAppointmentDetails').css('z-index', globals.zIndexPopup);
                globals.divBlockDetails = $('.divBlockDetails').css('z-index', globals.zIndexPopup);
                globals.divCellHighlight = $('#divCellHighlight').css('z-index', globals.zIndexCellHighlight);
                globals.divWorkTicketSelector = $('#divWorkTicketSelector').css('z-index', globals.zIndexPopup);
                globals.divWorkTicketSelector.hide();
            },
            buildColumns(parentDimension, booking: any = {}) {
                if (!booking.appointmentServices) {
                    booking.appointmentServices = [];
                }
                if (!booking.appointmentsAndBlocks) {
                    booking.appointmentsAndBlocks = [];
                }
                for (var innerDimension of parentDimension.innerDimensions) {
                    if (!innerDimension.innerDimensions) {
                        innerDimension.innerDimensions = [];
                    }
                    switch (innerDimension.dimensionType) {
                        case Meevo.Model.DimensionTypeEnum.Employee:
                            booking.employeeId = innerDimension.id;
                            booking.employeeName = innerDimension.headerText;
                            booking.displayName = innerDimension.displayName;
                            booking.foregroundColor = innerDimension.foregroundColor;
                            booking.backgroundColor = innerDimension.backgroundColor;
                            booking.genderEnum = innerDimension.genderEnum;
                            booking.isShared = innerDimension.isShared;
                            booking.managedByLocationId = innerDimension.managedByLocationId;
                            if (!booking.date && innerDimension.date) {
                                booking.date = moment(innerDimension.date).format('M/D/YYYY');
                                booking.fullDate = innerDimension.date;
                            }
                            if (booking.date) {
                                booking.columnId = helper.GetColumnId(booking.date, booking.employeeId);
                            }
                            booking.hoursPerformedInARow = innerDimension.hoursPerformedInARow;
                            booking.hoursPerformedPerDay = innerDimension.hoursPerformedPerDay;
                            booking.incrementMaskingText = innerDimension.incrementMaskingText;
                            booking.maskingIncrement = innerDimension.maskingIncrement;
                            break;
                        case Meevo.Model.DimensionTypeEnum.ResourceUnit:
                            booking.resourceUnitId = innerDimension.id;
                            booking.foregroundColor = innerDimension.foregroundColor;
                            booking.backgroundColor = innerDimension.backgroundColor;
                            booking.capacity = innerDimension.capacity;
                            if (!booking.date && innerDimension.date) {
                                booking.date = moment(innerDimension.date).format('M/D/YYYY');
                                booking.fullDate = innerDimension.date;
                            }
                            if (booking.date) {
                                booking.columnId = helper.GetColumnId(booking.date, booking.resourceUnitId);
                            }
                            break;
                        case Meevo.Model.DimensionTypeEnum.Date:
                            innerDimension.headerText = meevoDateFilter(moment(innerDimension.date).toDate());
                            booking.date = innerDimension.id;
                            booking.fullDate = innerDimension.date;
                            if (booking.employeeId || booking.resourceUnitId) {
                                booking.columnId = helper.GetColumnId(booking.date, booking.employeeId || booking.resourceUnitId);
                            }
                            break;
                        case Meevo.Model.DimensionTypeEnum.Resource:
                            booking.resourceId = innerDimension.id;
                            booking.shortcut = innerDimension.shortcut;
                            booking.displayName = innerDimension.displayName;
                            innerDimension.hasMultipleChildren = innerDimension.innerDimensions.length > 1;
                            innerDimension.parentDimension = parentDimension;
                            break;
                    }
                    if (innerDimension.isInPast !== undefined &&
                        innerDimension.isToday !== undefined &&
                        innerDimension.isInFuture !== undefined
                    ) {
                        booking.isInPast = innerDimension.isInPast;
                        booking.isToday = innerDimension.isToday;
                        booking.isInFuture = innerDimension.isInFuture;
                    }
                    // The leaf has been reached so add that to the column list
                    innerDimension.isLeaf = innerDimension.innerDimensions.length == 0;
                    parentDimension.isLeafParent = innerDimension.isLeaf;
                    if (innerDimension.isLeaf) {
                        if (parentDimension.dimensionType != Meevo.Model.DimensionTypeEnum.Resource ||
                            (parentDimension.dimensionType == Meevo.Model.DimensionTypeEnum.Resource && parentDimension.innerDimensions.length > 1)) {
                            globals.showLeaves = true;
                        }
                        let clone = jQuery.extend(true, {}, booking);
                        globals.totalColumnBookings.push(clone);
                        innerDimension.columnBooking = clone;
                    } else {
                        service.buildColumns(innerDimension, booking);
                    }
                }
            },

            WireUpEmptyCellClick(right, bottom) {
                globals.divCellHighlight.css('width', globals.columnWidth).css('height', globals.cellHeight);
                let lowZoomPaddingAdjustment = helper.getCellAppointmentTimePaddingAdjustment(globals.cellHeightPercent);
                if (lowZoomPaddingAdjustment != '') {
                    globals.divCellHighlight.css('padding-top', lowZoomPaddingAdjustment);
                }
                if (globals.columnWidthPercent == 20) {
                    globals.divCellHighlight.css('font-size', '0.5rem');
                }
                const divClickOverlay = $('#divClickOverlay').css('z-index', globals.zIndexClick);
                divClickOverlay.css('width', right - globals.timeColumnWidth).css('height', bottom);
                divClickOverlay.unbind()
                    .click(event => {
                        actions.appointmentBookClick(event);
                    })
                    .dblclick(event => {
                        actions.appointmentBookDoubleClick(event);
                    });
            },

            securityCanViewAll() {
                const deferred = $q.defer();

                const writeKey = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEWINGEMPLOYEEES_CANVIEWALL;

                security.checkSecurityKey(writeKey).then(securityResponse => {
                    globals.canViewAll = securityResponse === Meevo.Model.SecurityAccessEnum.Grant;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            securityCanViewResources() {
                const deferred = $q.defer();

                const key = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEW_RESOURCES + Meevo.Components.Common.SecurityParts.KEY_PART_READ;

                security.checkSecurityKey(key).then(securityResponse => {
                    globals.canViewResourcesAll = securityResponse === Meevo.Model.SecurityAccessEnum.Grant;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            securityCanViewEmployees() {
                const deferred = $q.defer();

                const key = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEW_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ;

                security.checkSecurityKey(key).then(securityResponse => {
                    globals.canViewEmployees = securityResponse === Meevo.Model.SecurityAccessEnum.Grant;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            securityCanUseTextel() {
                const deferred = $q.defer();
                const messengerKeys: string[] = [
                    `${Meevo.Components.Common.SecurityKeys.INTEGRATION_TWOWAYSMS}${Meevo.Components.Common.SecurityParts.KEY_PART_READ}`,
                    `${Meevo.Components.Common.SecurityKeys.INTEGRATION_TEXTEL}${Meevo.Components.Common.SecurityParts.KEY_PART_READ}`
                ];
                security.checkAndCache(messengerKeys)
                    .then((result: Meevo.Model.SecurityItem[]) => {
                        let twoWaySecItem = result.find((item) => item.key === messengerKeys[0]);
                        let textelSecItem = result.find((item) => item.key === messengerKeys[1]);

                        globals.twoWaySmsPermission = twoWaySecItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant;
                        globals.textelPermission = textelSecItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant;
                        deferred.resolve();
                    });

                return deferred.promise;
            },
            initialize(postInit) {
                globals.expandedColumns = [];
                $rootScope.onFirstLoad = true;

                const promises = [
                    /* 0 */ restServer.LoadBusinessInfo(),
                    /* 1 */ restServer.LoadBusinessInfoSettings(),
                    /* 2 */ this.securityCanViewAll(),
                    /* 3 */ this.checkResourceAvailability(),
                    /* 4 */ helper.loadMembershipTypeIcon(),
                    /* 5 */ restServer.LoadDaysBeforeBookingIsAllowed(),
                    /* 6 */ restServer.LoadDaysToEditTransaction(),
                    /* 7 */ restServer.loadWorkTypes(),
                    /* 8 */ this.securityCanUseTextel(),
                    /* 9 */ restServer.LoadNotificationSettings(),
                    /* 10 */ this.securityCanViewResources(),
                    /* 11 */ this.securityCanViewEmployees()
                ];

                $q.all(promises).then((result: any[]) => {
                    onBusinessInfoSuccess(result[0].data, result[1].data);

                    let employeeIds = globals.defaultEmployeeIds;
                    if (!_.isEmpty(filterActions.filteredEmployees)) {
                        employeeIds = _.pluck(filterActions.filteredEmployees, 'id');
                    }

                    filterActions.recalculateDate();

                        service.loadStructure(
                            filterActions.dates,
                            [],
                            helper.getFinalEmployeeFilters(employeeIds),
                            [],
                            [],
                            filterActions.displayNoShows,
                            filterActions.filteredPriceLevels,
                            filterActions.showCascadeView,
                            false,
                            filterActions.columnHeaderOrder,
                            filterActions.gender,
                            false,
                            true)
                            .then((result) => {
                                service.onApptBookStructureSuccess(result.data);
                                service.postInit = postInit;
                            });
  
                    let checkoutKey = Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_CHECKOUT;
                    security.checkSecurityKey(checkoutKey);

                    globals.daysBeforeBookingIsAllowed = result[5].data;
                    globals.daysToEditTransaction = result[6].data;
                    workTypes = result[7].data;

                    globals.isSmsEnabledCurrentLevel = result[9].data && result[9].data.isSmsEnabledCurrentLevel;
                });

                $(window).off('resize', onResize);
                $(window).on('resize', onResize);

                this.initializeEventHandlers();
            },
            initializeEventHandlers() {
                const resizeHandler = () => {
                    actions.CheckForAdjustEditor();
                };

                $(window)
                    .off('resize orientationchange', resizeHandler)
                    .on('resize orientationchange', resizeHandler);

                $(document)
                    .off('keyup.appointmentBook', keyupHandler)
                    .on('keyup.appointmentBook', keyupHandler);

                $timeout(() => {
                    const bookContainer = '#divAppointmentBookContainer';
                    $(bookContainer)
                        .off('click dblclick')
                        .on('click', `.appointment .nongap, .appointment .sideBackground`, (event) => {
                            const appointmentService = $(event.currentTarget).closest('.appointment');
                            actions.bookingClick(event, appointmentService[0]);
                        })
                        .on('dblclick', `.appointment .nongap, .appointment .sideBackground`, (event) => {
                            const appointmentService = $(event.currentTarget).closest('.appointment');
                            const id = appointmentService.data('id');
                            actions.bookingDoubleClick(event, id);
                        })
                        .on('click', `.appointment .gap`, (event) => {
                            actions.appointmentBookClick(event);
                        })
                        .on('dblclick', `.appointment .gap`, (event) => {
                            actions.appointmentBookDoubleClick(event);
                        })
                        .on('click', `.block`, (event) => {
                            actions.bookingClick(event, event.currentTarget);
                        })
                        .on('dblclick', `.block`, (event) => {
                            const id = $(event.currentTarget).data('id');
                            actions.bookingDoubleClick(event, id);
                        });

                    const rootContainer = '#divAppointmentBookRootContainer';
                    $(rootContainer)
                        .off('click')
                        .on('click', `.headerCell`, (event) => {
                            const currentTarget: any = event.currentTarget;
                            if (event.target.id == 'btnExpandCollapse') {
                                const id = currentTarget.id.substr(6);
                                const column: any = _.findWhere(globals.columnBookings, { columnId: id });
                                column.isExpanded = !column.isExpanded;
                                helper.AdjustColumns(id, column.isExpanded);
                            } else {
                                if (globals.isEmployeeView) {
                                    const employeeId = $(currentTarget).data('employeeId');
                                    if (employeeId) {
                                        const employeeColumn: any = _.findWhere(globals.columnBookings, { employeeId: employeeId });
                                        filterActions.updateFilters([], [{ id: employeeColumn.employeeId, displayName: employeeColumn.displayName, weeklyFilter: true }], [], null);
                                        filterActions.dates = [];
                                        filterActions.selectWeek(true);
                                    }
                                } else {
                                    const resourceId = $(currentTarget).data('resourceId');
                                    if (resourceId) {
                                        const resourceColumn: any = _.findWhere(globals.columnBookings, { resourceId: resourceId });
                                        filterActions.updateFilters([], [], [], [{ id: resourceColumn.resourceId, displayName: resourceColumn.displayName, shortcut: resourceColumn.shortcut, weeklyFilter: true }], null);
                                        filterActions.dates = [];
                                        filterActions.selectWeek(true);
                                    }
                                }
                            }
                        })
                        .on('click', `.headerCellRoot[data-dimension-type=${Meevo.Model.DimensionTypeEnum.Date}]`, (event) => {
                            if (filterActions.dateType === Meevo.Model.AppointmentBookDateTypeFilter.Week || filterActions.isPendingFilter) {
                                filterActions.dateType = Meevo.Model.AppointmentBookDateTypeFilter.Day;
                                filterActions.recalculateDate(moment(event.target.id.substr(4).replace(/-/g, "/")).toDate());
                                filterActions.columnHeaderOrder = undefined;
                                filterActions.clearFilters();
                                filterActions.filterBook();
                                filterActions.isPendingFilter = false;
                            }
                        });
                });
            },
            loadStructure(
                dates,
                employeeCategoryIds,
                employeeIds,
                serviceIds,
                resourceIds,
                includeNoShows,
                priceLevels,
                showInCascadeMode?: boolean,
                overrideTimeShift?: boolean,
                columnHeaderOrder?: string[],
                gender?: number,
                isPrecisionView?: boolean,
                bypassWriteStructure?: boolean) {

                const isEmployeeViewRestricted = globals.isEmployeeView && !globals.canViewEmployees;
                const isResourcesViewRestricted = !globals.isEmployeeView && !globals.canViewResourcesAll;

                if (getOpenBusinessHours().length === 0 || isEmployeeViewRestricted || isResourcesViewRestricted) {
                    globals.totalColumnBookings = [];
                    globals.disableDateChange = false;
                    return $q.reject();
                }
                return restServer.LoadAppointmentBookStructure(
                    globals.isEmployeeView,
                    dates,
                    employeeCategoryIds,
                    employeeIds,
                    serviceIds,
                    resourceIds,
                    includeNoShows,
                    priceLevels,
                    showInCascadeMode,
                    columnHeaderOrder,
                    filterActions.gender,
                    isPrecisionView)
                    .then(result => {
                        if (!bypassWriteStructure) {
                            helper.clearBook();
                            service.onApptBookStructureSuccess(result.data, overrideTimeShift);
                        }
                        return result;
                    });
            },
            checkResourceAvailability() {
                const request: any = {
                    pageNumber: 0,
                    itemsPerPage: 1,
                    sortDirection: Meevo.Model.SortDirection.Descending,
                    criteria: {
                        filter: '',
                        includeActive: true,
                        includeDeleted: false,
                        includeInactive: false
                    }
                };

                return dataService.getCount('Resource', request, null, '').then((response) => {
                    filterActions.resourcesAvailableCount = response;
                    if (response <= 0) {
                        globals.isEmployeeView = true;
                    }
                });
            },
            loadEvents() {
                return dataService.add(`/EventSchedule/List`, {
                    Criteria: {
                        startDate: filterActions.dates[0],
                        endDate: filterActions.dates[filterActions.dates.length - 1]
                    }
                });
            },
            loadPendings(dateEmployeePairs) {
                const dates = [];
                const employeeIds = [];
                for (let pair of dateEmployeePairs) {
                    pair.startDateTime = moment(pair.startDateTime).startOf('day').format();
                    if (!_.contains(dates, pair.startDateTime)) {
                        dates.push(pair.startDateTime);
                    }
                    if (!_.contains(employeeIds, pair.employeeId)) {
                        employeeIds.push(pair.employeeId);
                    }
                }
                service.loadStructure(dates, [], employeeIds, [], [], filterActions.displayNoShows,
                    filterActions.filteredPriceLevels, filterActions.showCascadeView, false,
                    filterActions.columnHeaderOrder, filterActions.gender, false, true).then(result => {
                        for (let dateDimension of result.data.innerDimensions) {
                            if (dateDimension.dimensionType !== Meevo.Model.DimensionTypeEnum.Date) {
                                continue;
                            }
                            for (let employeeIndex = dateDimension.innerDimensions.length - 1; employeeIndex >= 0; employeeIndex--) {
                                if (!_.findWhere(dateEmployeePairs, { startDateTime: moment(dateDimension.id).format(), employeeId: dateDimension.innerDimensions[employeeIndex].id })) {
                                    dateDimension.innerDimensions.splice(employeeIndex, 1);
                                }
                            }
                        }
                        service.onApptBookStructureSuccess(result.data);
                    });
            },
            scrollToTime(targetTime: string) {
                scrolledToTime = targetTime;
            }
        }

        $rootScope.$on('updateAppointmentOverlays', ()=> {
            service.applyOpacityFiltering(globals.opacityFilterSelections);
        });

        return service;
    }
]);